function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var fastEquals = require('fast-equals');
var chroma = _interopDefault(require('chroma-js'));
var reactToastify = require('react-toastify');
var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment-timezone'));
var reactSelect = require('react-select');
var Yup = require('yup');
var debounce = _interopDefault(require('lodash.debounce'));
var reactIntl = require('react-intl');
var uuid = require('uuid');
var broadcastChannel = require('broadcast-channel');

function setAqsErrorHelper(error) {
  return error ? {
    error: error && error.errors.pop(),
    errorCode: error.errorCode
  } : {
    error: null,
    errorCode: null
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

var documentAll_1 = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};

var documentAll$1 = documentAll_1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable = documentAll_1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var documentAll$2 = documentAll_1.all;

var isObject = documentAll_1.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll$2;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype.bind.bind(call, call);

var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};

var toString = functionUncurryThis({}.toString);
var stringSlice = functionUncurryThis(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString(it), 8, -1);
};

var $Object = Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isPure = false;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var defineGlobalProperty = function (key, value) {
  try {
    defineProperty(global_1, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || defineGlobalProperty(SHARED, {});

var sharedStore = store;

var shared = createCommonjsModule(function (module) {



(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.33.0',
  mode:  'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
});

var $Object$1 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$1(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString$1 = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var process$1 = global_1.process;
var Deno$1 = global_1.Deno;
var versions = process$1 && process$1.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */




var $String = global_1.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = symbolConstructorDetection
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var Symbol$1 = global_1.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var $String$1 = String;
var $TypeError$1 = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError$1($String$1(argument) + ' is not an object');
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var call$1 = Function.prototype.call;

var functionCall = functionBindNative ? call$1.bind(call$1) : function () {
  return call$1.apply(call$1, arguments);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global_1[namespace]) : global_1[namespace] && global_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var $Object$2 = Object;

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$2(it));
};

var $String$2 = String;

var tryToString = function (argument) {
  try {
    return $String$2(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$2 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError$2(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$3 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw new $TypeError$3("Can't convert object to primitive value");
};

var $TypeError$4 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError$4("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var $TypeError$5 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$5('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var hiddenKeys = {};

var indexOf = arrayIncludes.indexOf;


var push = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f$1 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};

var objectDefineProperties = {
	f: f$1
};

var html = getBuiltIn('document', 'documentElement');

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */








var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var defineProperty$1 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$1(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var WeakMap = global_1.WeakMap;

var weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global_1.TypeError;
var WeakMap$1 = global_1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store$1.get = store$1.get;
  store$1.has = store$1.has;
  store$1.set = store$1.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store$1.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store$1.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store$1.get(it) || {};
  };
  has = function (it) {
    return store$1.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$2 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$2
};

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$3 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$3
};

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;

var EXISTS$1 = hasOwnProperty_1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS$1 && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE$1 = EXISTS$1 && (!descriptors || (descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS$1,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE$1
};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var makeBuiltIn_1 = createCommonjsModule(function (module) {





var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;



var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = functionUncurryThis(''.slice);
var replace = functionUncurryThis(''.replace);
var join = functionUncurryThis([].join);

var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwnProperty_1(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (descriptors) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
      if (descriptors) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwnProperty_1(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$4
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$5 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$5
};

var concat = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var $Object$3 = Object;
var ObjectPrototype = $Object$3.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$3.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$3 ? ObjectPrototype : null;
};

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var defineProperty$2 = objectDefineProperty.f;



var TO_STRING_TAG = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwnProperty_1(target, TO_STRING_TAG)) {
    defineProperty$2(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var $String$3 = String;
var $TypeError$6 = TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw new $TypeError$6("Can't set " + $String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */




// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = functionUncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if ( CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ( IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return { value: value, done: done };
};

var defineProperty$3 = objectDefineProperty.f;





var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = iterators.Arguments = iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if ( descriptors && values.name !== 'values') try {
  defineProperty$3(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var ITERATOR$2 = wellKnownSymbol('iterator');
var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$1]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
    }
    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in domIterables) {
  handlePrototype(global_1[COLLECTION_NAME] && global_1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(domTokenListPrototype, 'DOMTokenList');

function removeDuplicates(input) {
  for (var _len = arguments.length, filterProperty = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filterProperty[_key - 1] = arguments[_key];
  }
  if (typeof input[0] !== 'object') return [...new Set(input)];
  const filterFunction = (filterProperty === null || filterProperty === void 0 ? void 0 : filterProperty.length) !== 0 ? isPropValuesEqual : fastEquals.deepEqual;
  return input.filter((item, index, array) => index === array.findIndex(searchItem => filterFunction(searchItem, item, filterProperty)));
}
function isPropValuesEqual(subject, target, propNames) {
  return propNames.every(propName => subject[propName] === target[propName]);
}

const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

var $TypeError$7 = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$7('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var engineIsNode = classofRaw(global_1.process) === 'process';

var $reduce = arrayReduce.left;




// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
_export({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat$1 = functionUncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
_export({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

const UfinetSelectBaseStyles = {
  control: (provided, _state) => Object.assign({}, provided, {
    cursor: 'pointer'
  }),
  menuPortal: base => Object.assign({}, base, {
    zIndex: 9999
  })
};
const emptyUfinetSelectOption = {
  label: '',
  value: ''
};

const defaultColor = '#000000';
const stringToColor = input => {
  const stringUniqueHash = [...input].reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);
  return "hsl(" + stringUniqueHash % 360 + ", 95%, 35%)";
};
const selectColorStyles = function selectColorStyles(getColor) {
  if (getColor === void 0) {
    getColor = stringToColor;
  }
  return Object.assign({}, UfinetSelectBaseStyles, {
    option: (styles, _ref) => {
      let {
        data,
        isDisabled,
        isFocused,
        isSelected
      } = _ref;
      const color = chroma(getColor(data.value));
      return Object.assign({}, styles, {
        backgroundColor: isDisabled ? undefined : isSelected ? color.css() : isFocused ? color.alpha(0.1).css() : undefined,
        color: isDisabled ? '#ccc' : isSelected ? chroma.contrast(color, 'white') > 2 ? 'white' : 'black' : color.css(),
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': Object.assign({}, styles[':active'], {
          backgroundColor: !isDisabled ? isSelected ? color.css() : color.alpha(0.3).css() : undefined
        })
      });
    },
    input: (styles, _ref2) => {
      let {
        isMulti
      } = _ref2;
      return !isMulti ? Object.assign({}, styles, dot()) : Object.assign({}, styles);
    },
    placeholder: (styles, _ref3) => {
      let {
        isMulti
      } = _ref3;
      return !isMulti ? Object.assign({}, styles, dot('#ccc')) : Object.assign({}, styles);
    },
    singleValue: (styles, _ref4) => {
      let {
        data,
        isMulti
      } = _ref4;
      return !isMulti ? Object.assign({}, styles, dot(data.color)) : Object.assign({}, styles);
    },
    multiValueLabel: (styles, _ref5) => {
      let {
        data
      } = _ref5;
      return Object.assign({}, styles, {
        backgroundColor: chroma(getColor(data.value)).alpha(0.3).css()
      });
    },
    multiValueRemove: (styles, _ref6) => {
      let {
        data
      } = _ref6;
      return Object.assign({}, styles, {
        backgroundColor: chroma(getColor(data.value)).alpha(0.8).css()
      });
    }
  });
};
const dot = function dot(color) {
  if (color === void 0) {
    color = 'transparent';
  }
  return {
    alignItems: 'center',
    display: 'flex',
    ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 8,
      height: 10,
      width: 10
    }
  };
};

const NotificationTranslations = new Map([['BY_DEFAULT', 'BY_DEFAULT']]);
const TOAST_CONTAINER_ID = 123456789;

const defaultAreaTranslations = new Map([['BY_DEFAULT', 'BY_DEFAULT'], ['POR_DEFECTO', 'BY_DEFAULT'], ['Por defecto', 'BY_DEFAULT']]);
const costTranslations = new Map([...defaultAreaTranslations]);
function getTableTranslations(value, intl) {
  const intlKey = costTranslations.get(value);
  return intlKey ? intl.formatMessage({
    id: intlKey
  }) : value;
}
function getRemovableCosts(costs) {
  return costs.filter(cost => defaultAreaTranslations.get(cost.networkAreaName) === undefined);
}
function onSelectionChangePreventDefaultsRemoval(newSelectedValues, prevSelectedValues, allValues, setSelectedValues, warningMessage) {
  var _prevSelectedValues;
  if (prevSelectedValues === void 0) {
    prevSelectedValues = [];
  }
  const selectableValues = getRemovableCosts(newSelectedValues);
  if (newSelectedValues.length === allValues.length && selectableValues.length !== 0 && ((_prevSelectedValues = prevSelectedValues) === null || _prevSelectedValues === void 0 ? void 0 : _prevSelectedValues.length) === selectableValues.length) {
    setSelectedValues([]);
  } else {
    if (newSelectedValues.length > 0 && selectableValues.length === 0 || selectableValues.length !== newSelectedValues.length) {
      reactToastify.toast.dismiss();
      newSelectedValues.length !== allValues.length && reactToastify.toast.warn(warningMessage, {
        containerId: TOAST_CONTAINER_ID
      });
    }
    setSelectedValues(selectableValues);
  }
  return newSelectedValues.length === selectableValues.length;
}

(function (AreaType) {
  AreaType["ACCESS_AREA"] = "ACCESS_AREA";
  AreaType["ECONOMIC_MODEL_AREA"] = "ECONOMIC_MODEL_AREA";
  AreaType["INFRASTRUCTURE_AREA"] = "INFRASTRUCTURE_AREA";
  AreaType["METROPOLITAN_AREA"] = "METROPOLITAN_AREA";
  AreaType["NO_QUOTABLE_AREA"] = "NO_QUOTABLE_AREA";
  AreaType["OPTICAL_FIBER_AREA"] = "OPTICAL_FIBER_AREA";
})(exports.AreaType || (exports.AreaType = {}));
(function (AreaAccessStatus) {
  AreaAccessStatus["CONNECTED"] = "CONNECTED";
  AreaAccessStatus["NEAR_NETWORK"] = "NEAR_NETWORK";
  AreaAccessStatus["NOT_CONNECTED"] = "NOT_CONNECTED";
})(exports.AreaAccessStatus || (exports.AreaAccessStatus = {}));
const AreaTypeColors = new Map([[exports.AreaType.ACCESS_AREA, '#ff7f50'], [exports.AreaType.ECONOMIC_MODEL_AREA, '#ff1493'], [exports.AreaType.INFRASTRUCTURE_AREA, '#FF1A00'], [exports.AreaType.METROPOLITAN_AREA, '#daa520'], [exports.AreaType.NO_QUOTABLE_AREA, '#808080'], [exports.AreaType.OPTICAL_FIBER_AREA, '#699afa']]);
const AreaStatusColors = new Map([[exports.AreaAccessStatus.CONNECTED, '#008000'], [exports.AreaAccessStatus.NEAR_NETWORK, '#ff7f50'], [exports.AreaAccessStatus.NOT_CONNECTED, '#6e10a1']]);
const AreaTypeZindex = new Map([[exports.AreaType.ACCESS_AREA, 1000], [exports.AreaType.OPTICAL_FIBER_AREA, 900], [exports.AreaType.INFRASTRUCTURE_AREA, 800], [exports.AreaType.METROPOLITAN_AREA, 700], [exports.AreaType.ECONOMIC_MODEL_AREA, 600], [exports.AreaType.NO_QUOTABLE_AREA, 500]]);
const ZoneTypeOptions = [{
  label: 'Metropolitano',
  value: 'METROPOLITAN'
}, {
  label: 'Larga distancia',
  value: 'LONG_DISTANCE'
}];
const KmzMaxSize = 10 * 1024 * 1024;
(function (AreaColors) {
  AreaColors["COLOR_ACCESS_UNKNOWN"] = "#9E17E8";
  AreaColors["COLOR_ACCESS_CONNECTED"] = "#58CB4F";
  AreaColors["COLOR_ACCESS_NEAR_NETWORK"] = "#EA934A";
})(exports.AreaColors || (exports.AreaColors = {}));
const AccessAreaStatusArray = [{
  accessAreaStatus: exports.AreaAccessStatus.NOT_CONNECTED,
  tooltipId: 'ACCESS.NOT_CONNECTED',
  color: exports.AreaColors.COLOR_ACCESS_UNKNOWN
}, {
  accessAreaStatus: exports.AreaAccessStatus.CONNECTED,
  tooltipId: 'ACCESS.CONNECTED',
  color: exports.AreaColors.COLOR_ACCESS_CONNECTED
}, {
  accessAreaStatus: exports.AreaAccessStatus.NEAR_NETWORK,
  tooltipId: 'ACCESS.NEAR_NETWORK',
  color: exports.AreaColors.COLOR_ACCESS_NEAR_NETWORK
}];
const areaStatusToText = new Map([[exports.AreaAccessStatus.CONNECTED, 'AREA.STATUS.CONNECTED'], [exports.AreaAccessStatus.NEAR_NETWORK, 'AREA.STATUS.NEAR_NETWORK'], [exports.AreaAccessStatus.NOT_CONNECTED, 'AREA.STATUS.NOT_CONNECTED']]);

(function (PriceListType) {
  PriceListType[PriceListType["LOCAL"] = 226530000] = "LOCAL";
  PriceListType[PriceListType["REGIONAL"] = 226530001] = "REGIONAL";
})(exports.PriceListType || (exports.PriceListType = {}));
(function (BandwidthUnits) {
  BandwidthUnits[BandwidthUnits["KBPS"] = 226530001] = "KBPS";
  BandwidthUnits[BandwidthUnits["MBPS"] = 226530000] = "MBPS";
  BandwidthUnits[BandwidthUnits["GBPS"] = 226530002] = "GBPS";
  BandwidthUnits[BandwidthUnits["TBPS"] = 226530003] = "TBPS";
})(exports.BandwidthUnits || (exports.BandwidthUnits = {}));
const unitMappings = new Map([[exports.BandwidthUnits.KBPS, 'Kbps'], [exports.BandwidthUnits.MBPS, 'Mbps'], [exports.BandwidthUnits.GBPS, 'Gbps'], [exports.BandwidthUnits.TBPS, 'Tbps']]);

const InfrastructureTypeOptions = [{
  label: 'Subterráena',
  value: 'UNDERGROUND'
}, {
  label: 'Aérea',
  value: 'AERIAL'
}];

(function (InfrastructureType) {
  InfrastructureType["UNDERGROUND"] = "UNDERGROUND";
  InfrastructureType["AERIAL"] = "AERIAL";
})(exports.InfrastructureType || (exports.InfrastructureType = {}));
const infrastructureTypeMappings = new Map([['Subterránea', exports.InfrastructureType.UNDERGROUND], ['Aérea', exports.InfrastructureType.AERIAL], ['Underground', exports.InfrastructureType.UNDERGROUND], ['Aerial', exports.InfrastructureType.AERIAL]]);
(function (ZoneType) {
  ZoneType["METROPOLITAN"] = "METROPOLITAN";
  ZoneType["LONG_DISTANCE"] = "LONG_DISTANCE";
})(exports.ZoneType || (exports.ZoneType = {}));
const zoneTypeMappings = new Map([['Metropolitano', exports.ZoneType.METROPOLITAN], ['Larga distancia', exports.ZoneType.LONG_DISTANCE], ['Metropolitan', exports.ZoneType.METROPOLITAN], ['Long distance', exports.ZoneType.LONG_DISTANCE]]);

const formInitialCountryParams = {
  id: undefined,
  countryId: undefined,
  countryName: undefined,
  minimalDistanceBox: undefined,
  minimalDistanceCost: undefined,
  maximumCapacity: undefined,
  churnContract: undefined,
  priceEvolution: undefined,
  taxPercentageBrasil1: undefined,
  taxPercentageBrasil2: undefined,
  taxPercentageGuatemala1: undefined,
  taxPercentageGuatemala2: undefined
};
const SpecialCountries = [{
  id: '415E1018-77F5-E711-811D-70106FA7B041',
  name: 'Brasil'
}, {
  id: '3A9B9F0F-C6BD-E511-80FB-3863BB358F90',
  name: 'Guatemala'
}];

(function (NetworkItemType) {
  NetworkItemType["AIR_CABLE"] = "AIR_CABLE";
  NetworkItemType["SUBWAY_CABLE"] = "SUBWAY_CABLE";
  NetworkItemType["AIR_BOX"] = "AIR_BOX";
  NetworkItemType["SUBWAY_BOX"] = "SUBWAY_BOX";
})(exports.NetworkItemType || (exports.NetworkItemType = {}));
const networkItemTypeTranslations = new Map([[exports.NetworkItemType.AIR_CABLE, 'LOAD_TYPE.AIR_CABLE'], [exports.NetworkItemType.SUBWAY_CABLE, 'LOAD_TYPE.SUBWAY_CABLE'], [exports.NetworkItemType.AIR_BOX, 'LOAD_TYPE.AIR_BOX'], [exports.NetworkItemType.SUBWAY_BOX, 'LOAD_TYPE.SUBWAY_BOX']]);

class QuotationPointAddress {
  constructor(address) {
    this._type = 'ADDRESS';
    this.address = void 0;
    this.address = address;
  }
}
class QuotationPointCoordinates {
  constructor(coordinates, site) {
    this._type = 'COORDINATES';
    this.latitude = void 0;
    this.longitude = void 0;
    this.site = void 0;
    this.latitude = coordinates.latitude;
    this.longitude = coordinates.longitude;
    this.site = site;
  }
}
class QuotationPointPop {
  constructor(popId) {
    this._type = 'POP';
    this.popId = void 0;
    this.popId = popId;
  }
}

class QuotationProductInternet {
  constructor(id, bandwidth, bandwidthUnit, bandwidthUnitId, redundancyId, transmissionId, accessId, oversubscriptionId) {
    this._type = 'INTERNET';
    this.name = 'Internet';
    this.id = void 0;
    this.bandwidth = void 0;
    this.bandwidthUnit = void 0;
    this.bandwidthUnitId = void 0;
    this.redundancyId = void 0;
    this.transmissionId = void 0;
    this.accessId = void 0;
    this.oversubscriptionId = void 0;
    this.id = id;
    this.bandwidth = bandwidth;
    this.bandwidthUnit = bandwidthUnit;
    this.bandwidthUnitId = bandwidthUnitId;
    this.redundancyId = redundancyId;
    this.transmissionId = transmissionId;
    this.accessId = accessId;
    this.oversubscriptionId = oversubscriptionId;
  }
}
class QuotationProductTowering {
  constructor(id, structureType, colocationPosition, structureHeight, structureHeightId) {
    this._type = 'TOWERING';
    this.name = 'Towering';
    this.id = void 0;
    this.structureTypeId = void 0;
    this.collocationPositionId = void 0;
    this.structureHeight = void 0;
    this.structureHeightId = void 0;
    this.id = id;
    this.structureTypeId = structureType;
    this.collocationPositionId = colocationPosition;
    this.structureHeight = structureHeight;
    this.structureHeightId = structureHeightId;
  }
}
class QuotationProductCollocation {
  constructor(id, emplacementType, collocationUnit, collocationQuantity) {
    this._type = 'COLLOCATION';
    this.name = 'Colocación';
    this.id = void 0;
    this.emplacementTypeId = void 0;
    this.collocationUnitId = void 0;
    this.quantity = void 0;
    this.id = id;
    this.emplacementTypeId = emplacementType;
    this.collocationUnitId = collocationUnit;
    this.quantity = collocationQuantity;
  }
}
class QuotationProductDarkFiber {
  constructor(id, fiberNumber, sectionLength) {
    this._type = 'DARK_FIBER';
    this.name = 'Fibra oscura';
    this.id = void 0;
    this.fiberNumber = void 0;
    this.sectionLength = void 0;
    this.id = id;
    this.fiberNumber = fiberNumber;
    this.sectionLength = sectionLength;
  }
}
class QuotationProductEline {
  constructor(id, bandwidth, bandwidthUnit, bandwidthUnitId, transportLayer, technologyId, redundancyId, transmissionId, standardId, subStandardId) {
    this._type = 'ELINE';
    this.name = 'Capacidad';
    this.id = void 0;
    this.bandwidth = void 0;
    this.bandwidthUnit = void 0;
    this.transportLayer = void 0;
    this.bandwidthUnitId = void 0;
    this.technologyId = void 0;
    this.redundancyId = void 0;
    this.transmissionId = void 0;
    this.standardId = void 0;
    this.subStandardId = void 0;
    this.id = id;
    this.bandwidth = bandwidth;
    this.bandwidthUnit = bandwidthUnit;
    this.bandwidthUnitId = bandwidthUnitId;
    this.transportLayer = transportLayer;
    this.technologyId = technologyId;
    this.redundancyId = redundancyId;
    this.transmissionId = transmissionId;
    this.standardId = standardId;
    this.subStandardId = subStandardId;
  }
}
(function (ProductId) {
  ProductId["INTERNET"] = "4322F073-A5DE-EA11-A813-000D3AB701F8";
  ProductId["ELINE"] = "5CCBDD8E-A3DE-EA11-A813-000D3AB701F8";
  ProductId["COLOCATION_ID"] = "2090B772-A3DE-EA11-A813-000D3AB701F8";
  ProductId["CROSS_CONNECTION_ID"] = "B6C50552-D606-EB11-A812-000D3AB61BF0";
  ProductId["ENERGIA_ID"] = "BAC50552-D606-EB11-A812-000D3AB61BF0";
  ProductId["EQUIPO_ID"] = "AEC50552-D606-EB11-A812-000D3AB61BF0";
  ProductId["FIBRA_OSCURA_ID"] = "D2427D4A-A3DE-EA11-A813-000D3AB701F8";
  ProductId["INFRAESTRUCTURA_ID"] = "B8C50552-D606-EB11-A812-000D3AB61BF0";
  ProductId["PUNTUAL_ID"] = "B4C50552-D606-EB11-A812-000D3AB61BF0";
  ProductId["VSAT_ID"] = "C2C50552-D606-EB11-A812-000D3AB61BF0";
  ProductId["OUTSOURCING_ID"] = "C3AC3CD3-FEBB-EB11-BACC-000D3ADCDA55";
  ProductId["TOWERING_ID"] = "BCC50552-D606-EB11-A812-000D3AB61BF0";
})(exports.ProductId || (exports.ProductId = {}));
(function (TransportLayer) {
  TransportLayer["L2"] = "L2";
  TransportLayer["L3"] = "L3";
})(exports.TransportLayer || (exports.TransportLayer = {}));
const TransportLayerSelectOptions = [{
  label: 'L2',
  value: 'L2'
}, {
  label: 'L3',
  value: 'L3'
}];

(function (BulkQuotationStatus) {
  BulkQuotationStatus["PENDING"] = "PENDING";
  BulkQuotationStatus["SUCCESS"] = "SUCCESS";
  BulkQuotationStatus["ERROR"] = "ERROR";
  BulkQuotationStatus["WARNING"] = "WARNING";
})(exports.BulkQuotationStatus || (exports.BulkQuotationStatus = {}));
const TIMEOUT_BULK_ERROR_NOTIFICATION = 40000;

(function (QuotationConfirmationStatus) {
  QuotationConfirmationStatus[QuotationConfirmationStatus["Unconfirmed"] = 0] = "Unconfirmed";
  QuotationConfirmationStatus[QuotationConfirmationStatus["Confirming"] = 1] = "Confirming";
  QuotationConfirmationStatus[QuotationConfirmationStatus["Confirmed"] = 2] = "Confirmed";
})(exports.QuotationConfirmationStatus || (exports.QuotationConfirmationStatus = {}));
const initialQuotationIndividual = {
  aqsId: '',
  idPais: '',
  idGrupoCorporativo: '',
  idCliente: '',
  vanRentabilidadEstandarAqs: '-',
  vanRentabilidadRiesgoAqs: '-',
  tirRentabilidadEstandarAqs: '-',
  tirRentabilidadRiesgoAqs: '-',
  paybackRentabilidadEstandarAqs: '-',
  paybackRentabilidadRiesgoAqs: '-',
  estadoRentabilidadEstandarAqs: '-',
  estadoRentabilidadRiesgoAqs: '-',
  currency: '-',
  calculating: false,
  startDate: new Date(),
  outdated: false,
  services: [],
  confirmationStatus: exports.QuotationConfirmationStatus.Unconfirmed,
  isBulk: false
};
const initialQuotationBulk = Object.assign({}, initialQuotationIndividual, {
  isBulk: true
});
(function (QuotationCRMStatus) {
  QuotationCRMStatus["CREATE"] = "Create";
  QuotationCRMStatus["IN_PROGRESS"] = "In Progress";
})(exports.QuotationCRMStatus || (exports.QuotationCRMStatus = {}));

(function (ServiceType) {
  ServiceType["INTERNET"] = "Internet";
  ServiceType["ELINE"] = "Capacidad";
})(exports.ServiceType || (exports.ServiceType = {}));
const serviceTypeIds = new Map([[exports.ServiceType.INTERNET, '4322F073-A5DE-EA11-A813-000D3AB701F8'], [exports.ServiceType.ELINE, '5CCBDD8E-A3DE-EA11-A813-000D3AB701F8']]);
(function (ServiceLocalState) {
  ServiceLocalState["Created"] = "Created";
  ServiceLocalState["Computed"] = "Computed";
  ServiceLocalState["Computing"] = "Computing";
  ServiceLocalState["Deleting"] = "Deleting";
})(exports.ServiceLocalState || (exports.ServiceLocalState = {}));
const initialServiceIndividual = {
  serviceTypeSelect: emptyUfinetSelectOption,
  originPopSelect: emptyUfinetSelectOption,
  originAddress: '',
  originLatLng: '',
  originSite: '',
  originLatitude: undefined,
  originLongitude: undefined,
  destinationPopSelect: emptyUfinetSelectOption,
  destinationAddress: '',
  destinationLatLng: '',
  destinationSite: '',
  destinationLatitude: undefined,
  destinationLongitude: undefined,
  bandwidthSelect: {
    label: '',
    value: '',
    capacity: 0,
    bandwidth: 0,
    unit: exports.BandwidthUnits.MBPS
  },
  deadline: undefined,
  transportLayerSelect: emptyUfinetSelectOption,
  state: exports.ServiceLocalState.Created,
  accessSelect: emptyUfinetSelectOption,
  oversubscriptionSelect: emptyUfinetSelectOption,
  isBulk: false,
  technologySelect: emptyUfinetSelectOption,
  redundancySelect: emptyUfinetSelectOption,
  transmissionSelect: emptyUfinetSelectOption,
  standardSelect: emptyUfinetSelectOption,
  subStandardSelect: emptyUfinetSelectOption,
  darkFiberService: {
    fiberNumberSelect: emptyUfinetSelectOption,
    sectionLengthInput: 0
  }
};
const initialServiceBulk = Object.assign({}, initialServiceIndividual, {
  isBulk: true
});
(function (ServiceServerStatus) {
  ServiceServerStatus["CALCULATED"] = "CALCULATED";
  ServiceServerStatus["NOT_CALCULATED"] = "NOT_CALCULATED";
  ServiceServerStatus["NOT_VIABLE"] = "NOT_VIABLE";
  ServiceServerStatus["INVALID"] = "INVALID";
  ServiceServerStatus["UNKNOWN"] = "UNKNOWN";
})(exports.ServiceServerStatus || (exports.ServiceServerStatus = {}));

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var $Object$4 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$4(it), TO_STRING_TAG$3)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var $String$4 = String;

var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$4(argument);
};

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var RegExpPrototype = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwnProperty_1(R, 'flags') && objectIsPrototypeOf(RegExpPrototype, R)
    ? functionCall(regexpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;






var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = toString_1(R.source);
    var flags = toString_1(regexpGetFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

var _class;
(function (FrontEndApplication) {
  FrontEndApplication["PORTAL"] = "PORTAL";
  FrontEndApplication["AQS"] = "AQS";
  FrontEndApplication["GDE01"] = "GDE01";
  FrontEndApplication["GFA"] = "GFA";
  FrontEndApplication["FACT01"] = "FACT01";
  FrontEndApplication["COMM"] = "COMM";
  FrontEndApplication["FTTH"] = "FTTH";
  FrontEndApplication["NETW"] = "NETW";
  FrontEndApplication["GTI"] = "GTI";
  FrontEndApplication["OFE"] = "OFE";
})(exports.FrontEndApplication || (exports.FrontEndApplication = {}));
(function (PortalModules) {
  PortalModules["AUTH"] = "AUTH";
  PortalModules["APP"] = "APP";
})(exports.PortalModules || (exports.PortalModules = {}));
(function (AqsModules) {
  AqsModules["QUOT"] = "QUOT";
  AqsModules["KMZ"] = "KMZ";
  AqsModules["COST"] = "COST";
  AqsModules["CONF"] = "CONF";
  AqsModules["PREFEASIBILITY"] = "PRE";
})(exports.AqsModules || (exports.AqsModules = {}));
(function (GestionServiciosModules) {
  GestionServiciosModules["SERVICES"] = "SERVICES";
  GestionServiciosModules["CONF"] = "CONF";
  GestionServiciosModules["ORS"] = "ORS";
  GestionServiciosModules["EXCEPTION"] = "EXCEPTION";
})(exports.GestionServiciosModules || (exports.GestionServiciosModules = {}));
(function (GestionFacturasModules) {
  GestionFacturasModules["FACT"] = "FACT";
  GestionFacturasModules["CONF"] = "CONF";
  GestionFacturasModules["ORS"] = "ORS";
})(exports.GestionFacturasModules || (exports.GestionFacturasModules = {}));
var GestionTicketsModules;
(function (GestionTicketsModules) {
  GestionTicketsModules["CORPORATE"] = "CORP";
  GestionTicketsModules["FTTH"] = "FTTH";
  GestionTicketsModules["KNOWLEDGE"] = "KNWL";
})(GestionTicketsModules || (GestionTicketsModules = {}));
var GestionOfertasModules;
(function (GestionOfertasModules) {
  GestionOfertasModules["OFFERS"] = "OFE";
  GestionOfertasModules["QUOTATION"] = "COT";
})(GestionOfertasModules || (GestionOfertasModules = {}));
var FinanzasModules;
(function (FinanzasModules) {
  FinanzasModules["FACTURACION"] = "FO01";
})(FinanzasModules || (FinanzasModules = {}));
var FTTHModules;
(function (FTTHModules) {
  FTTHModules["CTO"] = "CTO";
  FTTHModules["CTOA"] = "CTOA";
  FTTHModules["CTOB"] = "CTOB";
  FTTHModules["CTOOVERAGE"] = "CTOC";
  FTTHModules["CTOPORT"] = "CTOP";
  FTTHModules["CTOPORTFIXED"] = "CTOPF";
  FTTHModules["PFS"] = "PFS";
  FTTHModules["PFSMODEL"] = "PFSM";
  FTTHModules["PFSPORTIN"] = "PFSPI";
  FTTHModules["PFSPORTOUT"] = "PFSPO";
  FTTHModules["POLYGON"] = "POLYGON";
  FTTHModules["POLYGONCOVERAGE"] = "POLYGONC";
  FTTHModules["POLYGONOPTIMIZATION"] = "POLYGONO";
  FTTHModules["BITACORA"] = "BITACORA";
  FTTHModules["CONEXIONES"] = "CONEXIONES";
  FTTHModules["GPONTREE"] = "GPON";
  FTTHModules["OPERATOR"] = "OPERATOR";
  FTTHModules["RESOURCESCHARACTERISTICS"] = "RESOURCESC";
  FTTHModules["PHYSICALNETWORK"] = "PHYSICALN";
  FTTHModules["RESOURCERELATIONSHIP"] = "RESOURCER";
  FTTHModules["RESOURCES"] = "RESOURCES";
  FTTHModules["SERVICES"] = "SERVICES";
  FTTHModules["SPLITTERPFP"] = "SPLITTERPF";
  FTTHModules["SPLITTERPFS"] = "SPLITTERPS";
  FTTHModules["VLANINVENTORY"] = "VLANI";
  FTTHModules["OLTREGISTRY"] = "OLTREG";
})(FTTHModules || (FTTHModules = {}));
var NetwModules;
(function (NetwModules) {
  NetwModules["CABLE"] = "CABLE";
})(NetwModules || (NetwModules = {}));
var CommissionsModules;
(function (CommissionsModules) {
  CommissionsModules["COMMISSIONS"] = "CM01";
  CommissionsModules["KAM"] = "CM02";
  CommissionsModules["AUTHORIZATION"] = "CM07";
  CommissionsModules["AUTHORIZATIONSYS"] = "CM14";
  CommissionsModules["GOALS"] = "CM16";
  CommissionsModules["CONFIG"] = "CM15";
  CommissionsModules["MULTIPLICATOR"] = "CM03";
  CommissionsModules["LIQUIDATE"] = "CM04";
  CommissionsModules["LIQUIDATERRHH"] = "CM09";
  CommissionsModules["CMSYSTEM"] = "CM11";
  CommissionsModules["MANAGER"] = "CM05";
  CommissionsModules["MULTIPLIERSYS"] = "CM12";
  CommissionsModules["LIQUIDATESYS"] = "CM13";
})(CommissionsModules || (CommissionsModules = {}));
(function (UserTypesEnum) {
  UserTypesEnum["INTERNAL_USER"] = "INTERNAL";
  UserTypesEnum["EXTERNAL_USER"] = "EXTERNAL";
  UserTypesEnum["UNDEFINED"] = "";
})(exports.UserTypesEnum || (exports.UserTypesEnum = {}));
const userTypeMappings = new Map([[exports.UserTypesEnum.INTERNAL_USER, 'USER.INTERNAL.NAME'], [exports.UserTypesEnum.EXTERNAL_USER, 'USER.EXTERNAL.NAME'], [exports.UserTypesEnum.UNDEFINED, 'USER.UNKNOWN.NAME']]);
(function (AuthorityModelAccess) {
  AuthorityModelAccess["READ"] = "R";
  AuthorityModelAccess["WRITE"] = "W";
  AuthorityModelAccess["UPDATE"] = "U";
  AuthorityModelAccess["DELETE"] = "D";
  AuthorityModelAccess["EXPORT"] = "E";
  AuthorityModelAccess["ADMIN"] = "A";
})(exports.AuthorityModelAccess || (exports.AuthorityModelAccess = {}));
class Authority {
  constructor(input) {
    this.model = void 0;
    this.toString = () => this.model.raw;
    this.equals = other => {
      return typeof other === 'object' ? this.model.raw === other.model.raw : this.model.raw === other;
    };
    this.getBase = () => this.model.base;
    this.getModule = () => this.model.module;
    this.getAccess = () => this.model.access;
    if (typeof input === 'object') {
      const {
        base,
        module,
        access
      } = input;
      this.model = {
        raw: base + "#" + module + "#" + access,
        base,
        module,
        access
      };
    } else {
      this.model = Authority.mkAuthorityModel(input);
    }
  }
  static mkAuthority(application, module, access) {
    return new Authority({
      base: application,
      module,
      access
    });
  }
  static mkAuthorityModel(auth) {
    const authParts = auth.split('#');
    return {
      raw: auth,
      base: authParts[0] || '',
      module: authParts[1] || '',
      access: authParts[2] || ''
    };
  }
  static mkReadAuthority(application, module) {
    return this.mkAuthority(application, module, exports.AuthorityModelAccess.READ);
  }
  static mkWriteAuthority(application, module) {
    return this.mkAuthority(application, module, exports.AuthorityModelAccess.WRITE);
  }
  static mkUpdateAuthority(application, module) {
    return this.mkAuthority(application, module, exports.AuthorityModelAccess.UPDATE);
  }
  static mkDeleteAuthority(application, module) {
    return this.mkAuthority(application, module, exports.AuthorityModelAccess.DELETE);
  }
  static mkExportAuthority(application, module) {
    return this.mkAuthority(application, module, exports.AuthorityModelAccess.EXPORT);
  }
  static mkAdminAuthority(application, module) {
    return this.mkAuthority(application, module, exports.AuthorityModelAccess.ADMIN);
  }
  hasAccess(input) {
    return this.model.access === input;
  }
  canRead() {
    return this.hasAccess(exports.AuthorityModelAccess.READ);
  }
  canWrite() {
    return this.hasAccess(exports.AuthorityModelAccess.WRITE);
  }
  canUpdate() {
    return this.hasAccess(exports.AuthorityModelAccess.UPDATE);
  }
  canDelete() {
    return this.hasAccess(exports.AuthorityModelAccess.DELETE);
  }
  canExport() {
    return this.hasAccess(exports.AuthorityModelAccess.EXPORT);
  }
  canAdmin() {
    return this.hasAccess(exports.AuthorityModelAccess.ADMIN);
  }
  isEmpty() {
    return !this.canRead() && !this.canWrite() && !this.canUpdate() && !this.canDelete() && !this.canExport() && !this.canAdmin();
  }
  static getQuotationPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.quotationModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.quotationModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.quotationModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.quotationModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.quotationModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.quotationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getOffersPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.offersModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.offersModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.offersModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.offersModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.offersModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.offersModuleAdmin.equals(r)) !== undefined
    };
  }
  static getOffersQuotationPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.offersQuotationModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.offersQuotationModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.offersQuotationModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.offersQuotationModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.offersQuotationModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.offersQuotationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getKmzLoadPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.kmzLoadModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.kmzLoadModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.kmzLoadModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.kmzLoadModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.kmzLoadModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.kmzLoadModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCostsPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.costsModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.costsModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.costsModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.costsModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.costsModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.costsModuleAdmin.equals(r)) !== undefined
    };
  }
  static getSecurityConfigPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.securityConfigModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.securityConfigModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.securityConfigModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.securityConfigModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.securityConfigModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.securityConfigModuleAdmin.equals(r)) !== undefined
    };
  }
  static getApplicationConfigPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.applicationsConfigModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.applicationsConfigModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.applicationsConfigModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.applicationsConfigModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.applicationsConfigModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.applicationsConfigModuleAdmin.equals(r)) !== undefined
    };
  }
  static getAqsConfigPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.aqsConfigurationModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.aqsConfigurationModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.aqsConfigurationModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.aqsConfigurationModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.aqsConfigurationModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.aqsConfigurationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getAqsPrefeasibilityPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.aqsPrefeasibilityModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.aqsPrefeasibilityModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.aqsPrefeasibilityModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.aqsPrefeasibilityModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.aqsPrefeasibilityModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.aqsConfigurationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getServicesPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.servicesModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.servicesModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.servicesModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.servicesModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.servicesModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.servicesModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGseConfigPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gseConfigurationModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gseConfigurationModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gseConfigurationModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gseConfigurationModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gseConfigurationModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gseConfigurationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGseORSPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gseORSModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gseORSModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gseORSModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gseORSModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gseORSModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gseORSModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGseExceptionPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gseExceptionModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gseExceptionModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gseExceptionModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gseExceptionModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gseExceptionModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gseExceptionModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGfaInvoicePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.facturasModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.facturasModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.facturasModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.facturasModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.facturasModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.facturasModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGfaConfigPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gfaConfigurationModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gfaConfigurationModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gfaConfigurationModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gfaConfigurationModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gfaConfigurationModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gfaConfigurationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGtiCorporatePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gtiCorporateModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gtiCorporateModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gtiCorporateModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gtiCorporateModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gtiCorporateModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gtiCorporateModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGtiFtthPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gtiFtthModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gtiFtthModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gtiFtthModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gtiFtthModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gtiFtthModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gtiFtthModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGtiKnowledgePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gtiKnowledgeModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gtiKnowledgeModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gtiKnowledgeModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gtiKnowledgeModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gtiKnowledgeModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gtiKnowledgeModuleAdmin.equals(r)) !== undefined
    };
  }
  static getFinanceBillingPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.financeBillingModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.financeBillingModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.financeBillingModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.financeBillingModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.financeBillingModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.financeBillingModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionsPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionKamPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionKamModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionKamModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionKamModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionKamModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionKamModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionKamModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionAuthorizationPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionAuthorizationModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionAuthorizationModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionAuthorizationModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionAuthorizationModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionAuthorizationModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionAuthorizationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionAuthorizationSysPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionAuthorizationSysModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionAuthorizationSysModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionAuthorizationSysModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionAuthorizationSysModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionAuthorizationSysModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionAuthorizationSysModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionGoalsPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionGoalsModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionGoalsModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionGoalsModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionGoalsModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionGoalsModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionGoalsModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionConfigPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionConfigModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionConfigModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionConfigModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionConfigModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionConfigModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionConfigModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionMultiplicatorPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionMultiplicatorModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionMultiplicatorModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionMultiplicatorModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionMultiplicatorModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionMultiplicatorModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionMultiplicatorModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionMultiplierSysPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionMultiplierSysModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionMultiplierSysModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionMultiplierSysModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionMultiplierSysModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionMultiplierSysModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionMultiplierSysModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionLiquidatePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionLiquidateModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionLiquidateModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionLiquidateModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionLiquidateModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionLiquidateModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionLiquidateModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionLiquidateRRHHPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionLiquidateRRHHModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionLiquidateRRHHModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionLiquidateRRHHModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionLiquidateRRHHModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionLiquidateRRHHModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionLiquidateRRHHModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionLiquidateSysPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionLiquidateSysModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionLiquidateSysModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionLiquidateSysModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionLiquidateSysModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionLiquidateSysModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionLiquidateSysModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionCmSystemPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionCmSystemModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionCmSystemModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionCmSystemModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionCmSystemModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionCmSystemModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionCmSystemModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCommissionManagerPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.commissionManagerModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.commissionManagerModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.commissionManagerModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.commissionManagerModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.commissionManagerModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.commissionManagerModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCTOPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.ctoModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.ctoModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.ctoModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.ctoModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.ctoModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.ctoModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCTOAPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.ctoaModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.ctoaModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.ctoaModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.ctoaModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.ctoaModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.ctoaModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCTOBPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.ctobModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.ctobModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.ctobModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.ctobModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.ctobModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.ctobModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCTOCoveragePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.ctoCoverageModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.ctoCoverageModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.ctoCoverageModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.ctoCoverageModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.ctoCoverageModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.ctoCoverageModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCTOPortPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.ctoPortModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.ctoPortModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.ctoPortModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.ctoPortModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.ctoPortModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.ctoPortModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCTOPortFixedPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.ctoPortFixedModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.ctoPortFixedModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.ctoPortFixedModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.ctoPortFixedModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.ctoPortFixedModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.ctoPortFixedModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPFSPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.pfsModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.pfsModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.pfsModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.pfsModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.pfsModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.pfsModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPFSModelPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.pfsModelModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.pfsModelModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.pfsModelModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.pfsModelModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.pfsModelModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.pfsModelModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPFSPortInPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.pfsPortInModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.pfsPortInModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.pfsPortInModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.pfsPortInModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.pfsPortInModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.pfsPortInModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPFSPortOutPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.pfsPortOutModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.pfsPortOutModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.pfsPortOutModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.pfsPortOutModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.pfsPortOutModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.pfsPortOutModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPolygonPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.polygonModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.polygonModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.polygonModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.polygonModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.polygonModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.polygonModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPolygonCoveragePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.polygonCoverageModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.polygonCoverageModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.polygonCoverageModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.polygonCoverageModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.polygonCoverageModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.polygonCoverageModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPolygonOptimizationPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.polygonOptimizationModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.polygonOptimizationModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.polygonOptimizationModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.polygonOptimizationModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.polygonOptimizationModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.polygonOptimizationModuleAdmin.equals(r)) !== undefined
    };
  }
  static getBitacoraPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.bitacoraModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.bitacoraModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.bitacoraModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.bitacoraModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.bitacoraModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.bitacoraModuleAdmin.equals(r)) !== undefined
    };
  }
  static getConexionesPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.conexionesModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.conexionesModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.conexionesModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.conexionesModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.conexionesModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.conexionesModuleAdmin.equals(r)) !== undefined
    };
  }
  static getGponTreePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.gponTreeModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.gponTreeModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.gponTreeModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.gponTreeModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.gponTreeModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.gponTreeModuleAdmin.equals(r)) !== undefined
    };
  }
  static getOperatorPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.operatorModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.operatorModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.operatorModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.operatorModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.operatorModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.operatorModuleAdmin.equals(r)) !== undefined
    };
  }
  static getResourcesCharacteristicsPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.resourcesCharacteristicsModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.resourcesCharacteristicsModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.resourcesCharacteristicsModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.resourcesCharacteristicsModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.resourcesCharacteristicsModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.resourcesCharacteristicsModuleAdmin.equals(r)) !== undefined
    };
  }
  static getPhysicalNetworkPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.physicalNetworkModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.physicalNetworkModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.physicalNetworkModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.physicalNetworkModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.physicalNetworkModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.physicalNetworkModuleAdmin.equals(r)) !== undefined
    };
  }
  static getResourceRelationshipPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.resourceRelationshipModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.resourceRelationshipModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.resourceRelationshipModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.resourceRelationshipModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.resourceRelationshipModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.resourceRelationshipModuleAdmin.equals(r)) !== undefined
    };
  }
  static getResourcesPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.resourcesModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.resourcesModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.resourcesModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.resourcesModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.resourcesModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.resourcesModuleAdmin.equals(r)) !== undefined
    };
  }
  static getServicesFtthPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.servicesFtthModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.servicesFtthModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.servicesFtthModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.servicesFtthModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.servicesFtthModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.servicesFtthModuleAdmin.equals(r)) !== undefined
    };
  }
  static getSplitterPfpPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.splitterPfpModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.splitterPfpModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.splitterPfpModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.splitterPfpModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.splitterPfpModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.splitterPfpModuleAdmin.equals(r)) !== undefined
    };
  }
  static getSplitterPfsPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.splitterPfsModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.splitterPfsModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.splitterPfsModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.splitterPfsModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.splitterPfsModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.splitterPfsModuleAdmin.equals(r)) !== undefined
    };
  }
  static getVlanInventoryPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.vlanInventoryModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.vlanInventoryModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.vlanInventoryModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.vlanInventoryModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.vlanInventoryModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.vlanInventoryModuleAdmin.equals(r)) !== undefined
    };
  }
  static getOltRegistryPermissions(roles) {
    return {
      canRead: roles.find(r => Authority.oltRegistryModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.oltRegistryModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.oltRegistryModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.oltRegistryModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.oltRegistryModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.oltRegistryModuleAdmin.equals(r)) !== undefined
    };
  }
  static getCablePermissions(roles) {
    return {
      canRead: roles.find(r => Authority.cableModuleRead.equals(r)) !== undefined,
      canWrite: roles.find(r => Authority.cableModuleWrite.equals(r)) !== undefined,
      canUpdate: roles.find(r => Authority.cableModuleUpdate.equals(r)) !== undefined,
      canDelete: roles.find(r => Authority.cableModuleDelete.equals(r)) !== undefined,
      canExport: roles.find(r => Authority.cableModuleExport.equals(r)) !== undefined,
      canAdmin: roles.find(r => Authority.cableModuleAdmin.equals(r)) !== undefined
    };
  }
  static isEmptyPermissions(permissions) {
    return !permissions.canRead && !permissions.canWrite && !permissions.canUpdate && !permissions.canDelete && !permissions.canExport && !permissions.canAdmin;
  }
}
_class = Authority;
Authority.authorityPortalBase = exports.FrontEndApplication.PORTAL;
Authority.authModuleName = exports.PortalModules.AUTH;
Authority.securityConfigModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.PORTAL, _class.authModuleName);
Authority.securityConfigModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.PORTAL, _class.authModuleName);
Authority.securityConfigModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.PORTAL, _class.authModuleName);
Authority.securityConfigModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.PORTAL, _class.authModuleName);
Authority.securityConfigModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.PORTAL, _class.authModuleName);
Authority.securityConfigModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.PORTAL, _class.authModuleName);
Authority.securityConfigModuleAll = [_class.securityConfigModuleRead, _class.securityConfigModuleWrite, _class.securityConfigModuleUpdate, _class.securityConfigModuleDelete, _class.securityConfigModuleExport, _class.securityConfigModuleAdmin];
Authority.applicationsConfigModuleName = exports.PortalModules.APP;
Authority.applicationsConfigModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.PORTAL, _class.applicationsConfigModuleName);
Authority.applicationsConfigModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.PORTAL, _class.applicationsConfigModuleName);
Authority.applicationsConfigModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.PORTAL, _class.applicationsConfigModuleName);
Authority.applicationsConfigModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.PORTAL, _class.applicationsConfigModuleName);
Authority.applicationsConfigModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.PORTAL, _class.applicationsConfigModuleName);
Authority.applicationsConfigModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.PORTAL, _class.applicationsConfigModuleName);
Authority.applicationsConfigModuleAll = [_class.applicationsConfigModuleRead, _class.applicationsConfigModuleWrite, _class.applicationsConfigModuleUpdate, _class.applicationsConfigModuleDelete, _class.applicationsConfigModuleExport, _class.applicationsConfigModuleAdmin];
Authority.authorityQuotationBase = exports.FrontEndApplication.AQS;
Authority.quotationModuleName = exports.AqsModules.QUOT;
Authority.quotationModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.AQS, _class.quotationModuleName);
Authority.quotationModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.AQS, _class.quotationModuleName);
Authority.quotationModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.AQS, _class.quotationModuleName);
Authority.quotationModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.AQS, _class.quotationModuleName);
Authority.quotationModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.AQS, _class.quotationModuleName);
Authority.quotationModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.AQS, _class.quotationModuleName);
Authority.quotationModuleAll = [_class.quotationModuleRead, _class.quotationModuleWrite, _class.quotationModuleUpdate, _class.quotationModuleDelete, _class.quotationModuleExport, _class.quotationModuleAdmin];
Authority.kmzLoadModuleName = exports.AqsModules.KMZ;
Authority.kmzLoadModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.AQS, _class.kmzLoadModuleName);
Authority.kmzLoadModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.AQS, _class.kmzLoadModuleName);
Authority.kmzLoadModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.AQS, _class.kmzLoadModuleName);
Authority.kmzLoadModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.AQS, _class.kmzLoadModuleName);
Authority.kmzLoadModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.AQS, _class.kmzLoadModuleName);
Authority.kmzLoadModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.AQS, _class.kmzLoadModuleName);
Authority.kmzLoadModuleAll = [_class.kmzLoadModuleRead, _class.kmzLoadModuleWrite, _class.kmzLoadModuleUpdate, _class.kmzLoadModuleDelete, _class.kmzLoadModuleExport, _class.kmzLoadModuleAdmin];
Authority.costsModuleName = exports.AqsModules.COST;
Authority.costsModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.AQS, _class.costsModuleName);
Authority.costsModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.AQS, _class.costsModuleName);
Authority.costsModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.AQS, _class.costsModuleName);
Authority.costsModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.AQS, _class.costsModuleName);
Authority.costsModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.AQS, _class.costsModuleName);
Authority.costsModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.AQS, _class.costsModuleName);
Authority.costsModuleAll = [_class.costsModuleRead, _class.costsModuleWrite, _class.costsModuleUpdate, _class.costsModuleDelete, _class.costsModuleExport, _class.costsModuleAdmin];
Authority.aqsConfigurationModuleName = exports.AqsModules.CONF;
Authority.aqsConfigurationModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.AQS, _class.aqsConfigurationModuleName);
Authority.aqsConfigurationModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.AQS, _class.aqsConfigurationModuleName);
Authority.aqsConfigurationModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.AQS, _class.aqsConfigurationModuleName);
Authority.aqsConfigurationModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.AQS, _class.aqsConfigurationModuleName);
Authority.aqsConfigurationModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.AQS, _class.aqsConfigurationModuleName);
Authority.aqsConfigurationModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.AQS, _class.aqsConfigurationModuleName);
Authority.aqsConfigurationModuleAll = [_class.aqsConfigurationModuleRead, _class.aqsConfigurationModuleWrite, _class.aqsConfigurationModuleUpdate, _class.aqsConfigurationModuleDelete, _class.aqsConfigurationModuleExport, _class.aqsConfigurationModuleAdmin];
Authority.aqsPrefeasibilityModuleName = exports.AqsModules.PREFEASIBILITY;
Authority.aqsPrefeasibilityModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.AQS, _class.aqsPrefeasibilityModuleName);
Authority.aqsPrefeasibilityModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.AQS, _class.aqsPrefeasibilityModuleName);
Authority.aqsPrefeasibilityModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.AQS, _class.aqsPrefeasibilityModuleName);
Authority.aqsPrefeasibilityModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.AQS, _class.aqsPrefeasibilityModuleName);
Authority.aqsPrefeasibilityModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.AQS, _class.aqsPrefeasibilityModuleName);
Authority.aqsPrefeasibilityModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.AQS, _class.aqsPrefeasibilityModuleName);
Authority.aqsPrefeasibilityModuleAll = [_class.aqsPrefeasibilityModuleRead, _class.aqsPrefeasibilityModuleWrite, _class.aqsPrefeasibilityModuleUpdate, _class.aqsPrefeasibilityModuleDelete, _class.aqsPrefeasibilityModuleExport, _class.aqsPrefeasibilityModuleAdmin];
Authority.authorityGseBase = exports.FrontEndApplication.GDE01;
Authority.servicesModuleName = exports.GestionServiciosModules.SERVICES;
Authority.servicesModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GDE01, _class.servicesModuleName);
Authority.servicesModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GDE01, _class.servicesModuleName);
Authority.servicesModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GDE01, _class.servicesModuleName);
Authority.servicesModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GDE01, _class.servicesModuleName);
Authority.servicesModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GDE01, _class.servicesModuleName);
Authority.servicesModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GDE01, _class.servicesModuleName);
Authority.servicesModuleAll = [_class.aqsConfigurationModuleRead, _class.aqsConfigurationModuleWrite, _class.aqsConfigurationModuleUpdate, _class.aqsConfigurationModuleDelete, _class.aqsConfigurationModuleExport, _class.aqsConfigurationModuleAdmin];
Authority.gseConfigurationModuleName = exports.GestionServiciosModules.CONF;
Authority.gseConfigurationModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GDE01, _class.gseConfigurationModuleName);
Authority.gseConfigurationModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GDE01, _class.gseConfigurationModuleName);
Authority.gseConfigurationModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GDE01, _class.gseConfigurationModuleName);
Authority.gseConfigurationModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GDE01, _class.gseConfigurationModuleName);
Authority.gseConfigurationModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GDE01, _class.gseConfigurationModuleName);
Authority.gseConfigurationModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GDE01, _class.gseConfigurationModuleName);
Authority.gseConfigurationModuleAll = [_class.gseConfigurationModuleRead, _class.gseConfigurationModuleWrite, _class.gseConfigurationModuleUpdate, _class.gseConfigurationModuleDelete, _class.gseConfigurationModuleExport, _class.gseConfigurationModuleAdmin];
Authority.gseORSModuleName = exports.GestionServiciosModules.ORS;
Authority.gseORSModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GDE01, _class.gseORSModuleName);
Authority.gseORSModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GDE01, _class.gseORSModuleName);
Authority.gseORSModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GDE01, _class.gseORSModuleName);
Authority.gseORSModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GDE01, _class.gseORSModuleName);
Authority.gseORSModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GDE01, _class.gseORSModuleName);
Authority.gseORSModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GDE01, _class.gseORSModuleName);
Authority.gseORSModuleAll = [_class.gseORSModuleRead, _class.gseORSModuleWrite, _class.gseORSModuleUpdate, _class.gseORSModuleDelete, _class.gseORSModuleExport, _class.gseORSModuleAdmin];
Authority.gseExceptionModuleName = exports.GestionServiciosModules.EXCEPTION;
Authority.gseExceptionModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GDE01, _class.gseExceptionModuleName);
Authority.gseExceptionModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GDE01, _class.gseExceptionModuleName);
Authority.gseExceptionModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GDE01, _class.gseExceptionModuleName);
Authority.gseExceptionModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GDE01, _class.gseExceptionModuleName);
Authority.gseExceptionModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GDE01, _class.gseExceptionModuleName);
Authority.gseExceptionModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GDE01, _class.gseExceptionModuleName);
Authority.gseExceptionModuleAll = [_class.gseExceptionModuleRead, _class.gseExceptionModuleWrite, _class.gseExceptionModuleUpdate, _class.gseExceptionModuleDelete, _class.gseExceptionModuleExport, _class.gseExceptionModuleAdmin];
Authority.authorityGfaBase = exports.FrontEndApplication.GFA;
Authority.facturasModuleName = exports.GestionFacturasModules.FACT;
Authority.facturasModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GFA, _class.facturasModuleName);
Authority.facturasModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GFA, _class.facturasModuleName);
Authority.facturasModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GFA, _class.facturasModuleName);
Authority.facturasModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GFA, _class.facturasModuleName);
Authority.facturasModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GFA, _class.facturasModuleName);
Authority.facturasModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GFA, _class.facturasModuleName);
Authority.facturasModuleAll = [_class.facturasModuleRead, _class.facturasModuleWrite, _class.facturasModuleUpdate, _class.facturasModuleDelete, _class.facturasModuleExport, _class.facturasModuleAdmin];
Authority.gfaConfigurationModuleName = exports.GestionFacturasModules.CONF;
Authority.gfaConfigurationModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GFA, _class.gfaConfigurationModuleName);
Authority.gfaConfigurationModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GFA, _class.gfaConfigurationModuleName);
Authority.gfaConfigurationModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GFA, _class.gfaConfigurationModuleName);
Authority.gfaConfigurationModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GFA, _class.gfaConfigurationModuleName);
Authority.gfaConfigurationModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GFA, _class.gfaConfigurationModuleName);
Authority.gfaConfigurationModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GFA, _class.gfaConfigurationModuleName);
Authority.gfaConfigurationModuleAll = [_class.gfaConfigurationModuleRead, _class.gfaConfigurationModuleWrite, _class.gfaConfigurationModuleUpdate, _class.gfaConfigurationModuleDelete, _class.gfaConfigurationModuleExport, _class.gfaConfigurationModuleAdmin];
Authority.authorityGtiBase = exports.FrontEndApplication.GTI;
Authority.gtiCorporateModuleName = GestionTicketsModules.CORPORATE;
Authority.gtiCorporateModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GTI, _class.gtiCorporateModuleName);
Authority.gtiCorporateModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GTI, _class.gtiCorporateModuleName);
Authority.gtiCorporateModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GTI, _class.gtiCorporateModuleName);
Authority.gtiCorporateModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GTI, _class.gtiCorporateModuleName);
Authority.gtiCorporateModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GTI, _class.gtiCorporateModuleName);
Authority.gtiCorporateModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GTI, _class.gtiCorporateModuleName);
Authority.gtiCorporateModuleAll = [_class.gtiCorporateModuleRead, _class.gtiCorporateModuleWrite, _class.gtiCorporateModuleUpdate, _class.gtiCorporateModuleDelete, _class.gtiCorporateModuleExport, _class.gtiCorporateModuleAdmin];
Authority.gtiFtthModuleName = GestionTicketsModules.FTTH;
Authority.gtiFtthModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GTI, _class.gtiFtthModuleName);
Authority.gtiFtthModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GTI, _class.gtiFtthModuleName);
Authority.gtiFtthModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GTI, _class.gtiFtthModuleName);
Authority.gtiFtthModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GTI, _class.gtiFtthModuleName);
Authority.gtiFtthModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GTI, _class.gtiFtthModuleName);
Authority.gtiFtthModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GTI, _class.gtiFtthModuleName);
Authority.gtiFtthModuleAll = [_class.gtiFtthModuleRead, _class.gtiFtthModuleWrite, _class.gtiFtthModuleUpdate, _class.gtiFtthModuleDelete, _class.gtiFtthModuleExport, _class.gtiFtthModuleAdmin];
Authority.gtiKnowledgeModuleName = GestionTicketsModules.KNOWLEDGE;
Authority.gtiKnowledgeModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.GTI, _class.gtiKnowledgeModuleName);
Authority.gtiKnowledgeModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.GTI, _class.gtiKnowledgeModuleName);
Authority.gtiKnowledgeModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.GTI, _class.gtiKnowledgeModuleName);
Authority.gtiKnowledgeModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.GTI, _class.gtiKnowledgeModuleName);
Authority.gtiKnowledgeModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.GTI, _class.gtiKnowledgeModuleName);
Authority.gtiKnowledgeModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.GTI, _class.gtiKnowledgeModuleName);
Authority.gtiKnowledgeModuleAll = [_class.gtiKnowledgeModuleRead, _class.gtiKnowledgeModuleWrite, _class.gtiKnowledgeModuleUpdate, _class.gtiKnowledgeModuleDelete, _class.gtiKnowledgeModuleExport, _class.gtiKnowledgeModuleAdmin];
Authority.authorityOfferBase = exports.FrontEndApplication.OFE;
Authority.offersModuleName = GestionOfertasModules.OFFERS;
Authority.offersModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.OFE, _class.offersModuleName);
Authority.offersModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.OFE, _class.offersModuleName);
Authority.offersModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.OFE, _class.offersModuleName);
Authority.offersModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.OFE, _class.offersModuleName);
Authority.offersModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.OFE, _class.offersModuleName);
Authority.offersModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.OFE, _class.offersModuleName);
Authority.offersModuleAll = [_class.offersModuleRead, _class.offersModuleWrite, _class.offersModuleUpdate, _class.offersModuleDelete, _class.offersModuleExport, _class.offersModuleAdmin];
Authority.offersQuotationModuleName = GestionOfertasModules.QUOTATION;
Authority.offersQuotationModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.OFE, _class.offersQuotationModuleName);
Authority.offersQuotationModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.OFE, _class.offersQuotationModuleName);
Authority.offersQuotationModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.OFE, _class.offersQuotationModuleName);
Authority.offersQuotationModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.OFE, _class.offersQuotationModuleName);
Authority.offersQuotationModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.OFE, _class.offersQuotationModuleName);
Authority.offersQuotationModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.OFE, _class.offersQuotationModuleName);
Authority.offersQuotationModuleAll = [_class.offersQuotationModuleRead, _class.offersQuotationModuleWrite, _class.offersQuotationModuleUpdate, _class.offersQuotationModuleDelete, _class.offersQuotationModuleExport, _class.offersQuotationModuleAdmin];
Authority.authorityFinanceBase = exports.FrontEndApplication.FACT01;
Authority.billingModuleName = FinanzasModules.FACTURACION;
Authority.financeBillingModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FACT01, _class.billingModuleName);
Authority.financeBillingModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FACT01, _class.billingModuleName);
Authority.financeBillingModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FACT01, _class.billingModuleName);
Authority.financeBillingModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FACT01, _class.billingModuleName);
Authority.financeBillingModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FACT01, _class.billingModuleName);
Authority.financeBillingModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FACT01, _class.billingModuleName);
Authority.financeBillingModuleAll = [_class.financeBillingModuleRead, _class.financeBillingModuleWrite, _class.financeBillingModuleUpdate, _class.financeBillingModuleDelete, _class.financeBillingModuleExport, _class.financeBillingModuleAdmin];
Authority.authorityCommisionBase = exports.FrontEndApplication.COMM;
Authority.commissionModuleName = CommissionsModules.COMMISSIONS;
Authority.commissionModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionModuleName);
Authority.commissionModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionModuleName);
Authority.commissionModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionModuleName);
Authority.commissionModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionModuleName);
Authority.commissionModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionModuleName);
Authority.commissionModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionModuleName);
Authority.commissionModuleAll = [_class.commissionModuleRead, _class.commissionModuleWrite, _class.commissionModuleUpdate, _class.commissionModuleDelete, _class.commissionModuleExport, _class.commissionModuleAdmin];
Authority.commissionKamModuleName = CommissionsModules.KAM;
Authority.commissionKamModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionKamModuleName);
Authority.commissionKamModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionKamModuleName);
Authority.commissionKamModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionKamModuleName);
Authority.commissionKamModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionKamModuleName);
Authority.commissionKamModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionKamModuleName);
Authority.commissionKamModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionModuleName);
Authority.commissionKamModuleAll = [_class.commissionKamModuleRead, _class.commissionKamModuleWrite, _class.commissionKamModuleUpdate, _class.commissionKamModuleDelete, _class.commissionKamModuleExport, _class.commissionKamModuleAdmin];
Authority.commissionAuthorizationModuleName = CommissionsModules.AUTHORIZATION;
Authority.commissionAuthorizationModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationModuleName);
Authority.commissionAuthorizationModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationModuleName);
Authority.commissionAuthorizationModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationModuleName);
Authority.commissionAuthorizationModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationModuleName);
Authority.commissionAuthorizationModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationModuleName);
Authority.commissionAuthorizationModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationModuleName);
Authority.commissionAuthorizationModuleAll = [_class.commissionAuthorizationModuleRead, _class.commissionAuthorizationModuleWrite, _class.commissionAuthorizationModuleUpdate, _class.commissionAuthorizationModuleDelete, _class.commissionAuthorizationModuleExport, _class.commissionAuthorizationModuleAdmin];
Authority.commissionAuthorizationSysModuleName = CommissionsModules.AUTHORIZATIONSYS;
Authority.commissionAuthorizationSysModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationSysModuleName);
Authority.commissionAuthorizationSysModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationSysModuleName);
Authority.commissionAuthorizationSysModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationSysModuleName);
Authority.commissionAuthorizationSysModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationSysModuleName);
Authority.commissionAuthorizationSysModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationSysModuleName);
Authority.commissionAuthorizationSysModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionAuthorizationSysModuleName);
Authority.commissionAuthorizationSysModuleAll = [_class.commissionAuthorizationSysModuleRead, _class.commissionAuthorizationSysModuleWrite, _class.commissionAuthorizationSysModuleUpdate, _class.commissionAuthorizationSysModuleDelete, _class.commissionAuthorizationSysModuleExport, _class.commissionAuthorizationModuleAdmin];
Authority.commissionGoalsModuleName = CommissionsModules.GOALS;
Authority.commissionGoalsModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionGoalsModuleName);
Authority.commissionGoalsModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionGoalsModuleName);
Authority.commissionGoalsModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionGoalsModuleName);
Authority.commissionGoalsModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionGoalsModuleName);
Authority.commissionGoalsModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionGoalsModuleName);
Authority.commissionGoalsModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionGoalsModuleName);
Authority.commissionGoalsModuleAll = [_class.commissionGoalsModuleRead, _class.commissionGoalsModuleWrite, _class.commissionGoalsModuleUpdate, _class.commissionGoalsModuleDelete, _class.commissionGoalsModuleExport, _class.commissionGoalsModuleAdmin];
Authority.commissionConfigModuleName = CommissionsModules.CONFIG;
Authority.commissionConfigModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionConfigModuleName);
Authority.commissionConfigModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionConfigModuleName);
Authority.commissionConfigModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionConfigModuleName);
Authority.commissionConfigModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionConfigModuleName);
Authority.commissionConfigModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionConfigModuleName);
Authority.commissionConfigModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionConfigModuleName);
Authority.commissionConfigModuleAll = [_class.commissionConfigModuleRead, _class.commissionConfigModuleWrite, _class.commissionConfigModuleUpdate, _class.commissionConfigModuleDelete, _class.commissionConfigModuleExport, _class.commissionConfigModuleAdmin];
Authority.commissionMultiplicatorModuleName = CommissionsModules.MULTIPLICATOR;
Authority.commissionMultiplicatorModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplicatorModuleName);
Authority.commissionMultiplicatorModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplicatorModuleName);
Authority.commissionMultiplicatorModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplicatorModuleName);
Authority.commissionMultiplicatorModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplicatorModuleName);
Authority.commissionMultiplicatorModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplicatorModuleName);
Authority.commissionMultiplicatorModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplicatorModuleName);
Authority.commissionMultiplicatorModuleAll = [_class.commissionMultiplicatorModuleRead, _class.commissionMultiplicatorModuleWrite, _class.commissionMultiplicatorModuleUpdate, _class.commissionMultiplicatorModuleDelete, _class.commissionMultiplicatorModuleExport, _class.commissionAuthorizationModuleAdmin];
Authority.commissionMultiplierSysModuleName = CommissionsModules.MULTIPLIERSYS;
Authority.commissionMultiplierSysModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplierSysModuleName);
Authority.commissionMultiplierSysModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplierSysModuleName);
Authority.commissionMultiplierSysModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplierSysModuleName);
Authority.commissionMultiplierSysModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplierSysModuleName);
Authority.commissionMultiplierSysModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplierSysModuleName);
Authority.commissionMultiplierSysModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionMultiplierSysModuleName);
Authority.commissionMultiplierSysModuleAll = [_class.commissionMultiplierSysModuleRead, _class.commissionMultiplierSysModuleWrite, _class.commissionMultiplierSysModuleUpdate, _class.commissionMultiplierSysModuleDelete, _class.commissionMultiplierSysModuleExport, _class.commissionMultiplierSysModuleAdmin];
Authority.commissionLiquidateModuleName = CommissionsModules.LIQUIDATE;
Authority.commissionLiquidateModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateModuleName);
Authority.commissionLiquidateModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateModuleName);
Authority.commissionLiquidateModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateModuleName);
Authority.commissionLiquidateModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateModuleName);
Authority.commissionLiquidateModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateModuleName);
Authority.commissionLiquidateModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateModuleName);
Authority.commissionLiquidateModuleAll = [_class.commissionLiquidateModuleRead, _class.commissionLiquidateModuleWrite, _class.commissionLiquidateModuleUpdate, _class.commissionLiquidateModuleDelete, _class.commissionLiquidateModuleExport, _class.commissionLiquidateModuleAdmin];
Authority.commissionLiquidateRRHHModuleName = CommissionsModules.LIQUIDATERRHH;
Authority.commissionLiquidateRRHHModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateRRHHModuleName);
Authority.commissionLiquidateRRHHModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateRRHHModuleName);
Authority.commissionLiquidateRRHHModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateRRHHModuleName);
Authority.commissionLiquidateRRHHModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateRRHHModuleName);
Authority.commissionLiquidateRRHHModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateRRHHModuleName);
Authority.commissionLiquidateRRHHModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateRRHHModuleName);
Authority.commissionLiquidateRRHHModuleAll = [_class.commissionLiquidateRRHHModuleRead, _class.commissionLiquidateRRHHModuleWrite, _class.commissionLiquidateRRHHModuleUpdate, _class.commissionLiquidateRRHHModuleDelete, _class.commissionLiquidateRRHHModuleExport, _class.commissionLiquidateRRHHModuleAdmin];
Authority.commissionLiquidateSysModuleName = CommissionsModules.LIQUIDATESYS;
Authority.commissionLiquidateSysModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateSysModuleName);
Authority.commissionLiquidateSysModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateSysModuleName);
Authority.commissionLiquidateSysModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateSysModuleName);
Authority.commissionLiquidateSysModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateSysModuleName);
Authority.commissionLiquidateSysModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateSysModuleName);
Authority.commissionLiquidateSysModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionLiquidateSysModuleName);
Authority.commissionLiquidateSysModuleAll = [_class.commissionLiquidateSysModuleRead, _class.commissionLiquidateSysModuleWrite, _class.commissionLiquidateSysModuleUpdate, _class.commissionLiquidateSysModuleDelete, _class.commissionLiquidateSysModuleExport, _class.commissionLiquidateSysModuleName];
Authority.commissionCmSystemModuleName = CommissionsModules.CMSYSTEM;
Authority.commissionCmSystemModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionCmSystemModuleName);
Authority.commissionCmSystemModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionCmSystemModuleName);
Authority.commissionCmSystemModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionCmSystemModuleName);
Authority.commissionCmSystemModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionCmSystemModuleName);
Authority.commissionCmSystemModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionCmSystemModuleName);
Authority.commissionCmSystemModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionCmSystemModuleName);
Authority.commissionCmSystemModuleAll = [_class.commissionCmSystemModuleRead, _class.commissionCmSystemModuleWrite, _class.commissionCmSystemModuleUpdate, _class.commissionCmSystemModuleDelete, _class.commissionCmSystemModuleExport, _class.commissionCmSystemModuleAdmin];
Authority.commissionManagerModuleName = CommissionsModules.MANAGER;
Authority.commissionManagerModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.COMM, _class.commissionManagerModuleName);
Authority.commissionManagerModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.COMM, _class.commissionManagerModuleName);
Authority.commissionManagerModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.COMM, _class.commissionManagerModuleName);
Authority.commissionManagerModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.COMM, _class.commissionManagerModuleName);
Authority.commissionManagerModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.COMM, _class.commissionManagerModuleName);
Authority.commissionManagerModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.COMM, _class.commissionManagerModuleName);
Authority.commissionManagerModuleAll = [_class.commissionManagerModuleRead, _class.commissionManagerModuleWrite, _class.commissionManagerModuleUpdate, _class.commissionManagerModuleDelete, _class.commissionManagerModuleExport, _class.commissionManagerModuleAdmin];
Authority.authorityFTTHBase = exports.FrontEndApplication.FTTH;
Authority.ctoModuleName = FTTHModules.CTO;
Authority.ctoModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.ctoModuleName);
Authority.ctoModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.ctoModuleName);
Authority.ctoModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.ctoModuleName);
Authority.ctoModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.ctoModuleName);
Authority.ctoModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.ctoModuleName);
Authority.ctoModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.ctoModuleName);
Authority.ctoModuleAll = [_class.ctoModuleRead, _class.ctoModuleWrite, _class.ctoModuleUpdate, _class.ctoModuleDelete, _class.ctoModuleExport, _class.ctoModuleAdmin];
Authority.ctoaModuleName = FTTHModules.CTOA;
Authority.ctoaModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.ctoaModuleName);
Authority.ctoaModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.ctoaModuleName);
Authority.ctoaModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.ctoaModuleName);
Authority.ctoaModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.ctoaModuleName);
Authority.ctoaModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.ctoaModuleName);
Authority.ctoaModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.ctoaModuleName);
Authority.ctoaModuleAll = [_class.ctoaModuleRead, _class.ctoaModuleWrite, _class.ctoaModuleUpdate, _class.ctoaModuleDelete, _class.ctoaModuleExport, _class.ctoaModuleAdmin];
Authority.ctobModuleName = FTTHModules.CTOB;
Authority.ctobModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.ctobModuleName);
Authority.ctobModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.ctobModuleName);
Authority.ctobModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.ctobModuleName);
Authority.ctobModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.ctobModuleName);
Authority.ctobModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.ctobModuleName);
Authority.ctobModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.ctobModuleName);
Authority.ctobModuleAll = [_class.ctobModuleRead, _class.ctobModuleWrite, _class.ctobModuleUpdate, _class.ctobModuleDelete, _class.ctobModuleExport, _class.ctobModuleAdmin];
Authority.ctoCoverageModuleName = FTTHModules.CTOOVERAGE;
Authority.ctoCoverageModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.ctoCoverageModuleName);
Authority.ctoCoverageModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.ctoCoverageModuleName);
Authority.ctoCoverageModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.ctoCoverageModuleName);
Authority.ctoCoverageModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.ctoCoverageModuleName);
Authority.ctoCoverageModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.ctoCoverageModuleName);
Authority.ctoCoverageModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.ctoCoverageModuleName);
Authority.ctoCoverageModuleAll = [_class.ctoCoverageModuleRead, _class.ctoCoverageModuleWrite, _class.ctoCoverageModuleUpdate, _class.ctoCoverageModuleDelete, _class.ctoCoverageModuleExport, _class.ctoCoverageModuleAdmin];
Authority.ctoPortModuleName = FTTHModules.CTOPORT;
Authority.ctoPortModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortModuleName);
Authority.ctoPortModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortModuleName);
Authority.ctoPortModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortModuleName);
Authority.ctoPortModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortModuleName);
Authority.ctoPortModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortModuleName);
Authority.ctoPortModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortModuleName);
Authority.ctoPortModuleAll = [_class.ctoPortModuleRead, _class.ctoPortModuleWrite, _class.ctoPortModuleUpdate, _class.ctoPortModuleDelete, _class.ctoPortModuleExport, _class.ctoPortModuleAdmin];
Authority.ctoPortFixedModuleName = FTTHModules.CTOPORTFIXED;
Authority.ctoPortFixedModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortFixedModuleName);
Authority.ctoPortFixedModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortFixedModuleName);
Authority.ctoPortFixedModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortFixedModuleName);
Authority.ctoPortFixedModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortFixedModuleName);
Authority.ctoPortFixedModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortFixedModuleName);
Authority.ctoPortFixedModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.ctoPortFixedModuleName);
Authority.ctoPortFixedModuleAll = [_class.ctoPortFixedModuleRead, _class.ctoPortFixedModuleWrite, _class.ctoPortFixedModuleUpdate, _class.ctoPortFixedModuleDelete, _class.ctoPortFixedModuleExport, _class.ctoPortFixedModuleAdmin];
Authority.pfsModuleName = FTTHModules.PFS;
Authority.pfsModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.pfsModuleName);
Authority.pfsModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.pfsModuleName);
Authority.pfsModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.pfsModuleName);
Authority.pfsModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.pfsModuleName);
Authority.pfsModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.pfsModuleName);
Authority.pfsModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.pfsModuleName);
Authority.pfsModuleAll = [_class.pfsModuleRead, _class.pfsModuleWrite, _class.pfsModuleUpdate, _class.pfsModuleDelete, _class.pfsModuleExport, _class.pfsModuleAdmin];
Authority.pfsModelModuleName = FTTHModules.PFSMODEL;
Authority.pfsModelModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.pfsModelModuleName);
Authority.pfsModelModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.pfsModelModuleName);
Authority.pfsModelModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.pfsModelModuleName);
Authority.pfsModelModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.pfsModelModuleName);
Authority.pfsModelModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.pfsModelModuleName);
Authority.pfsModelModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.pfsModelModuleName);
Authority.pfsModelModuleAll = [_class.pfsModelModuleRead, _class.pfsModelModuleWrite, _class.pfsModelModuleUpdate, _class.pfsModelModuleDelete, _class.pfsModelModuleExport, _class.pfsModelModuleAdmin];
Authority.pfsPortInModuleName = FTTHModules.PFSPORTIN;
Authority.pfsPortInModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortInModuleName);
Authority.pfsPortInModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortInModuleName);
Authority.pfsPortInModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortInModuleName);
Authority.pfsPortInModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortInModuleName);
Authority.pfsPortInModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortInModuleName);
Authority.pfsPortInModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortInModuleName);
Authority.pfsPortInModuleAll = [_class.pfsPortInModuleRead, _class.pfsPortInModuleWrite, _class.pfsPortInModuleUpdate, _class.pfsPortInModuleDelete, _class.pfsPortInModuleExport, _class.pfsPortInModuleAdmin];
Authority.pfsPortOutModuleName = FTTHModules.PFSPORTOUT;
Authority.pfsPortOutModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortOutModuleName);
Authority.pfsPortOutModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortOutModuleName);
Authority.pfsPortOutModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortOutModuleName);
Authority.pfsPortOutModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortOutModuleName);
Authority.pfsPortOutModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortOutModuleName);
Authority.pfsPortOutModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.pfsPortOutModuleName);
Authority.pfsPortOutModuleAll = [_class.pfsPortOutModuleRead, _class.pfsPortOutModuleWrite, _class.pfsPortOutModuleUpdate, _class.pfsPortOutModuleDelete, _class.pfsPortOutModuleExport, _class.pfsPortOutModuleAdmin];
Authority.polygonModuleName = FTTHModules.POLYGON;
Authority.polygonModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.polygonModuleName);
Authority.polygonModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.polygonModuleName);
Authority.polygonModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.polygonModuleName);
Authority.polygonModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.polygonModuleName);
Authority.polygonModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.polygonModuleName);
Authority.polygonModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.polygonModuleName);
Authority.polygonModuleAll = [_class.polygonModuleRead, _class.polygonModuleWrite, _class.polygonModuleUpdate, _class.polygonModuleDelete, _class.polygonModuleExport, _class.polygonModuleAdmin];
Authority.polygonCoverageModuleName = FTTHModules.POLYGONCOVERAGE;
Authority.polygonCoverageModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.polygonCoverageModuleName);
Authority.polygonCoverageModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.polygonCoverageModuleName);
Authority.polygonCoverageModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.polygonCoverageModuleName);
Authority.polygonCoverageModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.polygonCoverageModuleName);
Authority.polygonCoverageModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.polygonCoverageModuleName);
Authority.polygonCoverageModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.polygonCoverageModuleName);
Authority.polygonCoverageModuleAll = [_class.polygonCoverageModuleRead, _class.polygonCoverageModuleWrite, _class.polygonCoverageModuleUpdate, _class.polygonCoverageModuleDelete, _class.polygonCoverageModuleExport, _class.polygonCoverageModuleAdmin];
Authority.polygonOptimizationModuleName = FTTHModules.POLYGONOPTIMIZATION;
Authority.polygonOptimizationModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.polygonOptimizationModuleName);
Authority.polygonOptimizationModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.polygonOptimizationModuleName);
Authority.polygonOptimizationModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.polygonOptimizationModuleName);
Authority.polygonOptimizationModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.polygonOptimizationModuleName);
Authority.polygonOptimizationModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.polygonOptimizationModuleName);
Authority.polygonOptimizationModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.polygonOptimizationModuleName);
Authority.polygonOptimizationModuleAll = [_class.polygonOptimizationModuleRead, _class.polygonOptimizationModuleWrite, _class.polygonOptimizationModuleUpdate, _class.polygonOptimizationModuleDelete, _class.polygonOptimizationModuleExport, _class.polygonOptimizationModuleAdmin];
Authority.bitacoraModuleName = FTTHModules.BITACORA;
Authority.bitacoraModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.bitacoraModuleName);
Authority.bitacoraModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.bitacoraModuleName);
Authority.bitacoraModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.bitacoraModuleName);
Authority.bitacoraModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.bitacoraModuleName);
Authority.bitacoraModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.bitacoraModuleName);
Authority.bitacoraModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.bitacoraModuleName);
Authority.bitacoraModuleAll = [_class.bitacoraModuleRead, _class.bitacoraModuleWrite, _class.bitacoraModuleUpdate, _class.bitacoraModuleDelete, _class.bitacoraModuleExport, _class.bitacoraModuleAdmin];
Authority.conexionesModuleName = FTTHModules.CONEXIONES;
Authority.conexionesModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.conexionesModuleName);
Authority.conexionesModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.conexionesModuleName);
Authority.conexionesModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.conexionesModuleName);
Authority.conexionesModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.conexionesModuleName);
Authority.conexionesModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.conexionesModuleName);
Authority.conexionesModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.conexionesModuleName);
Authority.conexionesModuleAll = [_class.conexionesModuleRead, _class.conexionesModuleWrite, _class.conexionesModuleUpdate, _class.conexionesModuleDelete, _class.conexionesModuleExport, _class.conexionesModuleAdmin];
Authority.gponTreeModuleName = FTTHModules.GPONTREE;
Authority.gponTreeModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.gponTreeModuleName);
Authority.gponTreeModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.gponTreeModuleName);
Authority.gponTreeModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.gponTreeModuleName);
Authority.gponTreeModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.gponTreeModuleName);
Authority.gponTreeModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.gponTreeModuleName);
Authority.gponTreeModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.gponTreeModuleName);
Authority.gponTreeModuleAll = [_class.gponTreeModuleRead, _class.gponTreeModuleWrite, _class.gponTreeModuleUpdate, _class.gponTreeModuleDelete, _class.gponTreeModuleExport, _class.gponTreeModuleAdmin];
Authority.operatorModuleName = FTTHModules.OPERATOR;
Authority.operatorModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.operatorModuleName);
Authority.operatorModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.operatorModuleName);
Authority.operatorModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.operatorModuleName);
Authority.operatorModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.operatorModuleName);
Authority.operatorModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.operatorModuleName);
Authority.operatorModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.operatorModuleName);
Authority.operatorModuleAll = [_class.operatorModuleRead, _class.operatorModuleWrite, _class.operatorModuleUpdate, _class.operatorModuleDelete, _class.operatorModuleExport, _class.operatorModuleAdmin];
Authority.resourcesCharacteristicsModuleName = FTTHModules.RESOURCESCHARACTERISTICS;
Authority.resourcesCharacteristicsModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.resourcesCharacteristicsModuleName);
Authority.resourcesCharacteristicsModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.resourcesCharacteristicsModuleName);
Authority.resourcesCharacteristicsModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.resourcesCharacteristicsModuleName);
Authority.resourcesCharacteristicsModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.resourcesCharacteristicsModuleName);
Authority.resourcesCharacteristicsModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.resourcesCharacteristicsModuleName);
Authority.resourcesCharacteristicsModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.resourcesCharacteristicsModuleName);
Authority.resourcesCharacteristicsModuleAll = [_class.resourcesCharacteristicsModuleRead, _class.resourcesCharacteristicsModuleWrite, _class.resourcesCharacteristicsModuleUpdate, _class.resourcesCharacteristicsModuleDelete, _class.resourcesCharacteristicsModuleExport, _class.resourcesCharacteristicsModuleAdmin];
Authority.physicalNetworkModuleName = FTTHModules.PHYSICALNETWORK;
Authority.physicalNetworkModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.physicalNetworkModuleName);
Authority.physicalNetworkModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.physicalNetworkModuleName);
Authority.physicalNetworkModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.physicalNetworkModuleName);
Authority.physicalNetworkModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.physicalNetworkModuleName);
Authority.physicalNetworkModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.physicalNetworkModuleName);
Authority.physicalNetworkModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.physicalNetworkModuleName);
Authority.physicalNetworkModuleAll = [_class.physicalNetworkModuleRead, _class.physicalNetworkModuleWrite, _class.physicalNetworkModuleUpdate, _class.physicalNetworkModuleDelete, _class.physicalNetworkModuleExport, _class.physicalNetworkModuleAdmin];
Authority.resourceRelationshipModuleName = FTTHModules.RESOURCERELATIONSHIP;
Authority.resourceRelationshipModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.resourceRelationshipModuleName);
Authority.resourceRelationshipModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.resourceRelationshipModuleName);
Authority.resourceRelationshipModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.resourceRelationshipModuleName);
Authority.resourceRelationshipModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.resourceRelationshipModuleName);
Authority.resourceRelationshipModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.resourceRelationshipModuleName);
Authority.resourceRelationshipModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.resourceRelationshipModuleName);
Authority.resourceRelationshipModuleAll = [_class.resourceRelationshipModuleRead, _class.resourceRelationshipModuleWrite, _class.resourceRelationshipModuleUpdate, _class.resourceRelationshipModuleDelete, _class.resourceRelationshipModuleExport, _class.resourceRelationshipModuleAdmin];
Authority.resourcesModuleName = FTTHModules.RESOURCES;
Authority.resourcesModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.resourcesModuleName);
Authority.resourcesModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.resourcesModuleName);
Authority.resourcesModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.resourcesModuleName);
Authority.resourcesModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.resourcesModuleName);
Authority.resourcesModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.resourcesModuleName);
Authority.resourcesModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.resourcesModuleName);
Authority.resourcesModuleAll = [_class.resourcesModuleRead, _class.resourcesModuleWrite, _class.resourcesModuleUpdate, _class.resourcesModuleDelete, _class.resourcesModuleExport, _class.resourcesModuleAdmin];
Authority.servicesFtthModuleName = FTTHModules.SERVICES;
Authority.servicesFtthModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.servicesFtthModuleName);
Authority.servicesFtthModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.servicesFtthModuleName);
Authority.servicesFtthModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.servicesFtthModuleName);
Authority.servicesFtthModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.servicesFtthModuleName);
Authority.servicesFtthModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.servicesFtthModuleName);
Authority.servicesFtthModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.servicesFtthModuleName);
Authority.servicesFtthModuleAll = [_class.servicesFtthModuleRead, _class.servicesFtthModuleWrite, _class.servicesFtthModuleUpdate, _class.servicesFtthModuleDelete, _class.servicesFtthModuleExport, _class.servicesFtthModuleAdmin];
Authority.splitterPfpModuleName = FTTHModules.SPLITTERPFP;
Authority.splitterPfpModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfpModuleName);
Authority.splitterPfpModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfpModuleName);
Authority.splitterPfpModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfpModuleName);
Authority.splitterPfpModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfpModuleName);
Authority.splitterPfpModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfpModuleName);
Authority.splitterPfpModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfpModuleName);
Authority.splitterPfpModuleAll = [_class.splitterPfpModuleRead, _class.splitterPfpModuleWrite, _class.splitterPfpModuleUpdate, _class.splitterPfpModuleDelete, _class.splitterPfpModuleExport, _class.splitterPfpModuleAdmin];
Authority.splitterPfsModuleName = FTTHModules.SPLITTERPFS;
Authority.splitterPfsModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfsModuleName);
Authority.splitterPfsModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfsModuleName);
Authority.splitterPfsModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfsModuleName);
Authority.splitterPfsModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfsModuleName);
Authority.splitterPfsModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfsModuleName);
Authority.splitterPfsModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.splitterPfsModuleName);
Authority.splitterPfsModuleAll = [_class.splitterPfsModuleRead, _class.splitterPfsModuleWrite, _class.splitterPfsModuleUpdate, _class.splitterPfsModuleDelete, _class.splitterPfsModuleExport, _class.splitterPfsModuleAdmin];
Authority.vlanInventoryModuleName = FTTHModules.VLANINVENTORY;
Authority.vlanInventoryModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.vlanInventoryModuleName);
Authority.vlanInventoryModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.vlanInventoryModuleName);
Authority.vlanInventoryModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.vlanInventoryModuleName);
Authority.vlanInventoryModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.vlanInventoryModuleName);
Authority.vlanInventoryModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.vlanInventoryModuleName);
Authority.vlanInventoryModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.vlanInventoryModuleName);
Authority.vlanInventoryModuleAll = [_class.vlanInventoryModuleRead, _class.vlanInventoryModuleWrite, _class.vlanInventoryModuleUpdate, _class.vlanInventoryModuleDelete, _class.vlanInventoryModuleExport, _class.vlanInventoryModuleAdmin];
Authority.oltRegistryModuleName = FTTHModules.OLTREGISTRY;
Authority.oltRegistryModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.FTTH, _class.oltRegistryModuleName);
Authority.oltRegistryModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.FTTH, _class.oltRegistryModuleName);
Authority.oltRegistryModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.FTTH, _class.oltRegistryModuleName);
Authority.oltRegistryModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.FTTH, _class.oltRegistryModuleName);
Authority.oltRegistryModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.FTTH, _class.oltRegistryModuleName);
Authority.oltRegistryModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.oltRegistryModuleName);
Authority.oltRegistryModuleAll = [_class.oltRegistryModuleRead, _class.oltRegistryModuleWrite, _class.oltRegistryModuleUpdate, _class.oltRegistryModuleDelete, _class.oltRegistryModuleExport, _class.oltRegistryModuleAdmin];
Authority.authorityNetwBase = exports.FrontEndApplication.NETW;
Authority.cableModuleName = NetwModules.CABLE;
Authority.cableModuleRead = _class.mkReadAuthority(exports.FrontEndApplication.NETW, _class.cableModuleName);
Authority.cableModuleWrite = _class.mkWriteAuthority(exports.FrontEndApplication.NETW, _class.cableModuleName);
Authority.cableModuleUpdate = _class.mkUpdateAuthority(exports.FrontEndApplication.NETW, _class.cableModuleName);
Authority.cableModuleDelete = _class.mkDeleteAuthority(exports.FrontEndApplication.NETW, _class.cableModuleName);
Authority.cableModuleExport = _class.mkExportAuthority(exports.FrontEndApplication.NETW, _class.cableModuleName);
Authority.cableModuleAdmin = _class.mkAdminAuthority(exports.FrontEndApplication.FTTH, _class.cableModuleName);
Authority.cableModuleAll = [_class.cableModuleRead, _class.cableModuleWrite, _class.cableModuleUpdate, _class.cableModuleDelete, _class.cableModuleExport, _class.cableModuleAdmin];
const allModulePermissions = {
  canRead: true,
  canWrite: true,
  canUpdate: true,
  canDelete: true,
  canExport: true,
  canAdmin: true
};

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global_1.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global_1.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp$2 = global_1.RegExp;

var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp$2('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */







var getInternalState$1 = internalState.get;



var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = functionUncurryThis(''.charAt);
var indexOf$1 = functionUncurryThis(''.indexOf);
var replace = functionUncurryThis(''.replace);
var stringSlice$1 = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString_1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$1(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$1(match.input, charsAdded);
        match[0] = stringSlice$1(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

var FunctionPrototype$2 = Function.prototype;
var apply = FunctionPrototype$2.apply;
var call$2 = FunctionPrototype$2.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call$2.bind(apply) : function () {
  return call$2.apply(apply, arguments);
});

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
};

// TODO: Remove from `core-js@4` since it's moved to entry points








var SPECIES = wellKnownSymbol('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = functionUncurryThisClause(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThisClause(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype$2[SYMBOL], 'sham', true);
};

var charAt$1 = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var stringSlice$2 = functionUncurryThis(''.slice);

var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var floor$1 = Math.floor;
var charAt$3 = functionUncurryThis(''.charAt);
var replace$1 = functionUncurryThis(''.replace);
var stringSlice$3 = functionUncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$3(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$1(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$3(ch, 1) : captures[f - 1] + charAt$3(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var $TypeError$8 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw new $TypeError$8('RegExp#exec called on incompatible receiver');
};

var REPLACE = wellKnownSymbol('replace');
var max$1 = Math.max;
var min$2 = Math.min;
var concat$2 = functionUncurryThis([].concat);
var push$1 = functionUncurryThis([].push);
var stringIndexOf = functionUncurryThis(''.indexOf);
var stringSlice$4 = functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? functionCall(replacer, searchValue, O, replaceValue)
        : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString_1(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regexpExecAbstract(rx, S);
        if (result === null) break;

        push$1(results, result);
        if (!global) break;

        var matchStr = toString_1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString_1(result[0]);
        var position = max$1(min$2(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$1(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$2([matched], captures, position, S);
          if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
          replacement = toString_1(functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var replace$2 = functionUncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = toString_1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var PROPER_FUNCTION_NAME$2 = functionName.PROPER;



var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$2 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $trim = stringTrim.trim;


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
_export({ target: 'String', proto: true, forced: stringTrimForced('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) === 'RegExp');
};

var defineProperty$5 = objectDefineProperty.f;

var proxyAccessor = function (Target, Source, key) {
  key in Target || defineProperty$5(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, { setter: true });
  return objectDefineProperty.f(target, name, descriptor);
};

var SPECIES$1 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (descriptors && Constructor && !Constructor[SPECIES$1]) {
    defineBuiltInAccessor(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;









var enforceInternalState = internalState.enforce;





var MATCH$1 = wellKnownSymbol('match');
var NativeRegExp = global_1.RegExp;
var RegExpPrototype$3 = NativeRegExp.prototype;
var SyntaxError = global_1.SyntaxError;
var exec = functionUncurryThis(RegExpPrototype$3.exec);
var charAt$4 = functionUncurryThis(''.charAt);
var replace$3 = functionUncurryThis(''.replace);
var stringIndexOf$1 = functionUncurryThis(''.indexOf);
var stringSlice$5 = functionUncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY$1 = regexpStickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = descriptors &&
  (!CORRECT_NEW || MISSED_STICKY$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg || fails(function () {
    re2[MATCH$1] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$4(string, index);
    if (chr === '\\') {
      result += chr + charAt$4(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$4(string, index);
    if (chr === '\\') {
      chr += charAt$4(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice$5(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwnProperty_1(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced_1('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = objectIsPrototypeOf(RegExpPrototype$3, this);
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || objectIsPrototypeOf(RegExpPrototype$3, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = regexpGetFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString_1(pattern);
    flags = flags === undefined ? '' : toString_1(flags);
    rawPattern = pattern;

    if (regexpUnsupportedDotAll && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$3(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY$1 && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$2) flags = replace$3(flags, /y/g, '');
    }

    if (regexpUnsupportedNcg) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$3, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys$1 = getOwnPropertyNames(NativeRegExp), index = 0; keys$1.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys$1[index++]);
  }

  RegExpPrototype$3.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$3;
  defineBuiltIn(global_1, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var getInternalState$2 = internalState.get;

var RegExpPrototype$4 = RegExp.prototype;
var $TypeError$9 = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (descriptors && regexpUnsupportedDotAll) {
  defineBuiltInAccessor(RegExpPrototype$4, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype$4) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classofRaw(this) === 'RegExp') {
        return !!getInternalState$2(this).dotAll;
      }
      throw new $TypeError$9('Incompatible receiver, RegExp required');
    }
  });
}

var normalizeStringArgument = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString_1(argument);
};

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};

var $Error = Error;
var replace$4 = functionUncurryThis(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$4(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var errorStackInstallable = !fails(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (errorStackInstallable) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', errorStackClear(stack, dropEntries));
  }
};

var wrapErrorConstructorWithCause = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if ( hasOwnProperty_1(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    errorStackInstall(result, WrappedError, result.stack, 2);
    if (this && objectIsPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (objectSetPrototypeOf) objectSetPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (descriptors && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */





var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global_1[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$1 = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$1);
  _export({ global: true, constructor: true, arity: 1, forced: FORCED$1 }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$1);
    _export({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED$1 }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return functionApply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return functionApply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return functionApply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return functionApply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return functionApply(init, this, arguments); };
});

const domainMailRegExp = domain => {
  const curatedDomain = domain.trim().replace('.', '\\.').replace('@', '');
  return new RegExp(".+@" + curatedDomain + "$", 'i');
};
const internalMailRegExp = domainMailRegExp('ufinet.com');
const parseDomainFromEmail = email => {
  if (!email) throw new Error('No username');
  const emailParts = email.split('@');
  if (emailParts.length !== 2) throw new Error('Illegal username');
  return emailParts.pop();
};

(function (AuthStatus) {
  AuthStatus["LOGGED_OUT"] = "LOGGED_OUT";
  AuthStatus["VERIFYING"] = "VERIFYING";
  AuthStatus["LOGGED_IN"] = "LOGGED_IN";
})(exports.AuthStatus || (exports.AuthStatus = {}));
const InitialAuthData = {
  status: exports.AuthStatus.LOGGED_OUT,
  logout: () => {},
  setStatus: () => {},
  token: undefined,
  setToken: () => {},
  userData: undefined,
  setUser: () => {},
  authFrame: undefined,
  setAuthFrame: () => {},
  clear: () => {}
};
const AuthContext = /*#__PURE__*/React.createContext(InitialAuthData);
const useAuthData = () => {
  const authData = React.useContext(AuthContext);
  return authData;
};
(function (AuthEvent) {
  AuthEvent["LOGIN"] = "ufinet-sso-login";
  AuthEvent["LOGOUT"] = "ufinet-sso-logout";
  AuthEvent["LOGIN_FINISH"] = "ufinet-finish-login";
  AuthEvent["TOKEN_UPDATE"] = "ufinet-token-update";
})(exports.AuthEvent || (exports.AuthEvent = {}));
const localStorageAuthKey = 'ufinet-auth';

const userWithDetail = (userType, userProperties) => ({
  valid: (userProperties === null || userProperties === void 0 ? void 0 : userProperties.valid) || true,
  expired: (userProperties === null || userProperties === void 0 ? void 0 : userProperties.expired) || false,
  authorities: (userProperties === null || userProperties === void 0 ? void 0 : userProperties.authorities) || [],
  user: {
    fullName: 'testing user',
    type: userType
  },
  username: (userProperties === null || userProperties === void 0 ? void 0 : userProperties.username) || 'testing'
});
const user = function user(userType, roles) {
  if (roles === void 0) {
    roles = [];
  }
  return {
    valid: true,
    expired: false,
    authorities: roles.map(it => it.toString()),
    user: {
      fullName: 'testing user',
      type: userType
    },
    username: 'testing'
  };
};
const mockAuthData = _ref => {
  var _partialAuthData$clea, _partialAuthData$logo, _partialAuthData$setA, _partialAuthData$setS, _partialAuthData$setT, _partialAuthData$setU, _partialAuthData$stat, _partialAuthData$user;
  let {
    partialAuthData = {},
    authorities = [],
    userType = exports.UserTypesEnum.INTERNAL_USER
  } = _ref;
  return {
    clear: (_partialAuthData$clea = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.clear) != null ? _partialAuthData$clea : jest.fn(),
    logout: (_partialAuthData$logo = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.logout) != null ? _partialAuthData$logo : jest.fn(),
    setAuthFrame: (_partialAuthData$setA = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.setAuthFrame) != null ? _partialAuthData$setA : jest.fn(),
    setStatus: (_partialAuthData$setS = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.setStatus) != null ? _partialAuthData$setS : jest.fn(),
    setToken: (_partialAuthData$setT = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.setToken) != null ? _partialAuthData$setT : jest.fn(),
    setUser: (_partialAuthData$setU = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.setUser) != null ? _partialAuthData$setU : jest.fn(),
    status: (_partialAuthData$stat = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.status) != null ? _partialAuthData$stat : exports.AuthStatus.LOGGED_IN,
    userData: (_partialAuthData$user = partialAuthData === null || partialAuthData === void 0 ? void 0 : partialAuthData.userData) != null ? _partialAuthData$user : user(userType, authorities)
  };
};

class ComplexEnum {
  constructor(shape) {
    this.shape = void 0;
    this.shape = shape;
    this.shape = shape;
  }
  equals(other) {
    return fastEquals.deepEqual(this.shape, other.shape);
  }
}

class LabelValueEnum extends ComplexEnum {
  constructor(label, value) {
    super({
      label,
      value
    });
    this.label = void 0;
    this.value = void 0;
    this.label = label;
    this.value = value;
  }
}

(function (EAqsErrorCode) {
  EAqsErrorCode["KMZ_NOT_VALID"] = "KMZ_NOT_VALID";
  EAqsErrorCode["KMZ_COUNTRY_NOT_VALID"] = "KMZ_COUNTRY_NOT_VALID";
  EAqsErrorCode["DEFAULT"] = "";
})(exports.EAqsErrorCode || (exports.EAqsErrorCode = {}));

const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig';
const i18nInitialState = {
  selectedLang: 'es'
};
const I18nContext = /*#__PURE__*/React.createContext(i18nInitialState);

(function (OfferStatus) {
  OfferStatus["SUBMITTED"] = "SUBMITTED";
  OfferStatus["PENDINGAUTHORIZATION"] = "PENDINGAUTHORIZATION";
  OfferStatus["IN_ELABORATION"] = "IN_ELABORATION";
  OfferStatus["NOT_VIABLE"] = "NOT_VIABLE";
  OfferStatus["AWARD"] = "AWARD";
})(exports.OfferStatus || (exports.OfferStatus = {}));

const EmptyPagingData = {
  pageNumber: 0,
  pageSize: 0,
  totalElements: 0,
  totalPages: 0
};
const defaultPageNumber = 0;
const defaultPageSize = 20;
const defaultPagingParameters = {
  pageNumber: defaultPageNumber,
  pageSize: defaultPageSize
};
const mapFromPagedResponseToPagingData = pagedResponse => ({
  totalElements: pagedResponse.totalCount,
  totalPages: pagedResponse.totalPages,
  pageSize: pagedResponse.pageSize,
  pageNumber: pagedResponse.currentPage
});

const SelectOptionMapper = data => {
  return data.map(item => {
    return {
      label: "" + item.value,
      value: item.id
    };
  });
};
const SelectOptionTranslateMapper = (data, translate, translationBaseKey) => {
  return data.map(item => {
    return {
      label: translate(translationBaseKey + "." + item.value),
      value: item.id
    };
  });
};

(function (SortingDirection) {
  SortingDirection["ASCENDING"] = "ASC";
  SortingDirection["DESCENDING"] = "DESC";
})(exports.SortingDirection || (exports.SortingDirection = {}));

const noContentPlaceholder = '-';

const phoneRegExp = new RegExp('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$');

(function (ClientType) {
  ClientType["GOBIERNO"] = "GOBIERNO";
  ClientType["OPERADOR"] = "OPERADOR";
  ClientType["OTROS"] = "OTROS";
  ClientType["PROVEEDOR"] = "PROVEEDOR";
  ClientType["OTT"] = "OTT";
  ClientType["ELECTRICA"] = "ELECTRICA";
  ClientType["CORPORATIVO"] = "CORPORATIVO";
  ClientType["DATA_CENTER"] = "DATA_CENTER";
  ClientType["INTEGRADOR"] = "INTEGRADOR";
  ClientType["OPERADOR_LOCAL"] = "OPERADOR_LOCAL";
  ClientType["CLIENTE_INDIRECTO"] = "CLIENTE_INDIRECTO";
  ClientType["GRUPO_UFINET"] = "GRUPO_UFINET";
  ClientType["OPERADOR_GLOBAL"] = "OPERADOR_GLOBAL";
  ClientType["RESTO"] = "RESTO";
  ClientType["EXTERNO"] = "EXTERNO";
  ClientType["POSTERIA"] = "POSTERIA";
  ClientType["ISP"] = "ISP";
})(exports.ClientType || (exports.ClientType = {}));

const DATE_FORMAT = 'DD/MM/yyyy hh:mm';
function convertToLocalTZ(date) {
  return moment.utc(date).tz(moment.tz.guess()).format(DATE_FORMAT);
}
function formatDateToString(format, date, defaultDate) {
  if (defaultDate === void 0) {
    defaultDate = noContentPlaceholder;
  }
  return date ? moment(date).format(format) : defaultDate;
}
function isFormattedDate(date) {
  if (!date) return false;
  return moment(date, DATE_FORMAT, true).isValid();
}
function compareDates(date1, date2) {
  if (!date1 && !date2) return 0;
  if (!isFormattedDate(date1) && !isFormattedDate(date2)) return 0;
  if (!date1 || !isFormattedDate(date1)) return -1;
  if (!date2 || !isFormattedDate(date2)) return 1;
  const moment1 = moment(date1, DATE_FORMAT);
  const moment2 = moment(date2, DATE_FORMAT);
  if (moment1.isSame(moment2)) return 0;
  return moment1.isBefore(moment2) ? -1 : 1;
}

// @@match logic
fixRegexpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? functionCall(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString_1(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = toString_1(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var $TypeError$a = TypeError;

var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$a('Incorrect invocation');
};

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var $TypeError$b = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError$b(tryToString(argument) + ' is not a constructor');
};

var SPECIES$2 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};

var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var arraySlice = functionUncurryThis([].slice);

var $TypeError$c = TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw new $TypeError$c('Not enough arguments');
  return passed;
};

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(engineUserAgent);

var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$2 = global_1.process;
var Dispatch = global_1.Dispatch;
var Function$1 = global_1.Function;
var MessageChannel = global_1.MessageChannel;
var String$1 = global_1.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global_1.location;
});

var run = function (id) {
  if (hasOwnProperty_1(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global_1.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      functionApply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (engineIsNode) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !engineIsIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = functionBindContext(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global_1.addEventListener &&
    isCallable(global_1.postMessage) &&
    !global_1.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global_1.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear
};

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(engineUserAgent) && typeof Pebble != 'undefined';

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(engineUserAgent);

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var macrotask = task.set;






var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var document$2 = global_1.document;
var process$3 = global_1.process;
var Promise$1 = global_1.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue$2 = new queue$1();

  var flush = function () {
    var parent, fn;
    if (engineIsNode && (parent = process$3.domain)) parent.exit();
    while (fn = queue$2.get()) try {
      fn();
    } catch (error) {
      if (queue$2.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!engineIsIos && !engineIsNode && !engineIsWebosWebkit && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!engineIsIosPebble && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = functionBindContext(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (engineIsNode) {
    notify = function () {
      process$3.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = functionBindContext(macrotask, global_1);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue$2.head) notify();
    queue$2.add(fn);
  };
}

var microtask_1 = microtask;

var hostReportErrors = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var promiseNativeConstructor = global_1.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var engineIsBrowser = !engineIsDeno && !engineIsNode
  && typeof window == 'object'
  && typeof document == 'object';

var SPECIES$3 = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global_1.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced_1('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(promiseNativeConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(promiseNativeConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && engineV8Version === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!engineV8Version || engineV8Version < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new promiseNativeConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$3] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (engineIsBrowser || engineIsDeno) && !NATIVE_PROMISE_REJECTION_EVENT;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};

var $TypeError$d = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$d('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var f$6 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
	f: f$6
};

var task$1 = task.set;









var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT$1 = promiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = promiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var setInternalState$1 = internalState.set;
var NativePromisePrototype = promiseNativeConstructor && promiseNativeConstructor.prototype;
var PromiseConstructor = promiseNativeConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError$2 = global_1.TypeError;
var document$3 = global_1.document;
var process$4 = global_1.process;
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$2('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        functionCall(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify$1 = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask_1(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$3.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT$1 && (handler = global_1['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  functionCall(task$1, global_1, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (engineIsNode) {
          process$4.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = engineIsNode || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  functionCall(task$1, global_1, function () {
    var promise = state.facade;
    if (engineIsNode) {
      process$4.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$2("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask_1(function () {
        var wrapper = { done: false };
        try {
          functionCall(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    functionCall(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$1(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new queue$1(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = engineIsNode ? process$4.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask_1(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if ( isCallable(promiseNativeConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          functionCall(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (objectSetPrototypeOf) {
      objectSetPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

_export({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var ITERATOR$3 = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$3] === it);
};

var ITERATOR$4 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$4)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var $TypeError$e = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw new $TypeError$e(tryToString(argument) + ' is not iterable');
};

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

var $TypeError$f = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = functionBindContext(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$f(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = functionCall(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var ITERATOR$5 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$5] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$5] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$2 || !checkCorrectnessOfIteration(function (iterable) {
  promiseNativeConstructor.all(iterable).then(undefined, function () { /* empty */ });
});

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
_export({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        functionCall($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;





var NativePromisePrototype$1 = promiseNativeConstructor && promiseNativeConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
_export({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$3, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ( isCallable(promiseNativeConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype$1['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype$1, 'catch', method, { unsafe: true });
  }
}

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
_export({ target: 'Promise', stat: true, forced: promiseStaticsIncorrectIteration }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        functionCall($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var FORCED_PROMISE_CONSTRUCTOR$4 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
_export({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  reject: function reject(r) {
    var capability = newPromiseCapability.f(this);
    functionCall(capability.reject, undefined, r);
    return capability.promise;
  }
});

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var FORCED_PROMISE_CONSTRUCTOR$5 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
_export({ target: 'Promise', stat: true, forced:  FORCED_PROMISE_CONSTRUCTOR$5 }, {
  resolve: function resolve(x) {
    return promiseResolve( this, x);
  }
});

var charAt$5 = stringMultibyte.charAt;





var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = internalState.set;
var getInternalState$3 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
iteratorDefine(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: toString_1(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$3(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt$5(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

var ITERATOR$6 = wellKnownSymbol('iterator');

var urlConstructorDetection = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (isPure && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (isPure || !descriptors))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$6]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = functionCall(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var $Array$1 = Array;
var max$2 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array$1(max$2(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js


var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec$2 = functionUncurryThis(regexSeparators.exec);
var floor$2 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt$1 = functionUncurryThis(''.charCodeAt);
var join = functionUncurryThis([].join);
var push$2 = functionUncurryThis([].push);
var replace$5 = functionUncurryThis(''.replace);
var split$1 = functionUncurryThis(''.split);
var toLowerCase = functionUncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt$1(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt$1(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push$2(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$2(output, value);
        counter--;
      }
    } else {
      push$2(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$2(delta / damp) : delta >> 1;
  delta += floor$2(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$2(delta / baseMinusTMin);
    k += base;
  }
  return floor$2(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$2(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$2(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$2((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$2(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$2(qMinusT / baseMinusT);
          k += base;
        }

        push$2(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$1(replace$5(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$2(encoded, exec$2(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join(encoded, '.');
};

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

var floor$3 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$3(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySliceSimple(array, 0, middle), comparefn),
    mergeSort(arraySliceSimple(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`





























var ITERATOR$7 = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$3 = internalState.set;
var getInternalParamsState = internalState.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!descriptors) return global_1[name];
  var descriptor = getOwnPropertyDescriptor$3(global_1, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global_1.RegExp;
var TypeError$3 = global_1.TypeError;
var decodeURIComponent = global_1.decodeURIComponent;
var encodeURIComponent$1 = global_1.encodeURIComponent;
var charAt$6 = functionUncurryThis(''.charAt);
var join$1 = functionUncurryThis([].join);
var push$3 = functionUncurryThis([].push);
var replace$6 = functionUncurryThis(''.replace);
var shift = functionUncurryThis([].shift);
var splice = functionUncurryThis([].splice);
var split$2 = functionUncurryThis(''.split);
var stringSlice$6 = functionUncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$6(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$6(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$6(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = iteratorCreateConstructor(function Iterator(params, kind) {
  setInternalState$3(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$6(init, 0) === '?' ? stringSlice$6(init, 1) : init : toString_1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = functionCall(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = functionCall(entryNext, entryIterator)).done ||
          (second = functionCall(entryNext, entryIterator)).done ||
          !functionCall(entryNext, entryIterator).done
        ) throw new TypeError$3('Expected sequence with length 2');
        push$3(this.entries, { key: toString_1(first.value), value: toString_1(second.value) });
      }
    } else for (var key in object) if (hasOwnProperty_1(object, key)) {
      push$3(this.entries, { key: key, value: toString_1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split$2(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$2(attribute, '=');
          push$3(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$3(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$1(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$3(this, new URLSearchParamsState(init));
  if (!descriptors) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push$3(state.entries, { key: toString_1(name), value: toString_1(value) });
    if (!descriptors) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = toString_1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : toString_1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!descriptors) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$3(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : toString_1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = toString_1(name);
    var val = toString_1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$3(entries, { key: key, value: val });
    if (!descriptors) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = functionBindContext(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR$7, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (descriptors) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

_export({ global: true, constructor: true, forced: !urlConstructorDetection }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!urlConstructorDetection && isCallable(Headers)) {
  var headersHas = functionUncurryThis(HeadersPrototype.has);
  var headersSet = functionUncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return objectCreate(init, {
          body: createPropertyDescriptor(0, toString_1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    _export({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    _export({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`














var codeAt = stringMultibyte.codeAt;







var setInternalState$4 = internalState.set;
var getInternalURLState = internalState.getterFor('URL');
var URLSearchParams$1 = web_urlSearchParams_constructor.URLSearchParams;
var getInternalSearchParamsState = web_urlSearchParams_constructor.getState;

var NativeURL = global_1.URL;
var TypeError$4 = global_1.TypeError;
var parseInt$1 = global_1.parseInt;
var floor$4 = Math.floor;
var pow = Math.pow;
var charAt$7 = functionUncurryThis(''.charAt);
var exec$3 = functionUncurryThis(/./.exec);
var join$2 = functionUncurryThis([].join);
var numberToString = functionUncurryThis(1.0.toString);
var pop = functionUncurryThis([].pop);
var push$4 = functionUncurryThis([].push);
var replace$7 = functionUncurryThis(''.replace);
var shift$1 = functionUncurryThis([].shift);
var split$3 = functionUncurryThis(''.split);
var stringSlice$7 = functionUncurryThis(''.slice);
var toLowerCase$1 = functionUncurryThis(''.toLowerCase);
var unshift = functionUncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split$3(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt$7(part, 0) === '0') {
      radix = exec$3(HEX_START, part) ? 16 : 8;
      part = stringSlice$7(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec$3(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }
    push$4(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$7(input, pointer);
  };

  if (chr() === ':') {
    if (charAt$7(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec$3(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec$3(DIGIT, chr())) return;
        while (exec$3(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor$4(host / 256);
    } return join$2(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = objectAssign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = objectAssign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = objectAssign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwnProperty_1(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec$3(ALPHA, charAt$7(string, 0))
    && ((second = charAt$7(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$7(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt$7(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase$1(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase$1(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = toString_1(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError$4(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError$4(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = toString_1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$7(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace$7(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace$7(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec$3(ALPHA, chr)) {
            buffer += toLowerCase$1(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec$3(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase$1(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwnProperty_1(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$4(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySliceSimple(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt$7(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec$3(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySliceSimple(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySliceSimple(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySliceSimple(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join$2(arraySliceSimple(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySliceSimple(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join$2(arraySliceSimple(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$4(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$4(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$4(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$7(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$4(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift$1(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt$7(input, 0) === '[') {
      if (charAt$7(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$7(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec$3(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = stringPunycodeToAscii(input);
      if (exec$3(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwnProperty_1(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError$4(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse(toString_1(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom(toString_1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom(toString_1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : toString_1(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = toString_1(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join$2(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = toString_1(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt$7(search, 0) === '?') search = stringSlice$7(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = toString_1(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt$7(hash, 0) === '#') hash = stringSlice$7(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$4(that, new URLState(url, false, base));
  if (!descriptors) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (descriptors) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', functionBindContext(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', functionBindContext(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

_export({ global: true, constructor: true, forced: !urlConstructorDetection, sham: !descriptors }, {
  URL: URLConstructor
});

var URLSearchParamsPrototype$1 = URLSearchParams.prototype;
var forEach = functionUncurryThis(URLSearchParamsPrototype$1.forEach);

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (descriptors && !('size' in URLSearchParamsPrototype$1)) {
  defineBuiltInAccessor(URLSearchParamsPrototype$1, 'size', {
    get: function size() {
      var count = 0;
      forEach(this, function () { count++; });
      return count;
    },
    configurable: true,
    enumerable: true
  });
}

const browserDownload = function browserDownload(response) {
  try {
    var _response$headers$get;
    const match = (_response$headers$get = response.headers.get('Content-Disposition')) === null || _response$headers$get === void 0 ? void 0 : _response$headers$get.match(/(filename=)(.+$)/);
    const fileName = match ? match[2] : 'download';
    return Promise.resolve(response.blob()).then(function (blob) {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "" + fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
const emptyFileUploadData = {
  path: '',
  size: 0
};

const randomEnumElement = anEnum => {
  const enumValues = Object.values(anEnum);
  const randomIndex = Math.floor(Math.random() * enumValues.length);
  return enumValues[randomIndex];
};
const getEnumKeyFromEnumValue = (anEnum, enumValue) => {
  const valueIndex = Object.values(anEnum).indexOf(enumValue);
  if (valueIndex === -1) return undefined;
  return Object.keys(anEnum)[valueIndex];
};

const defaultFilterSettings = {
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
  matchFrom: 'any',
  stringify: option => option.label + " " + option.value
};
const onlyLabelFilterSettings = {
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
  matchFrom: 'any',
  stringify: option => option.label
};
const labelAndValueFilter = reactSelect.createFilter(Object.assign({}, defaultFilterSettings));
const onlyLabelFilter = reactSelect.createFilter(Object.assign({}, onlyLabelFilterSettings));
const onlyLabelAndBeginsWithLabelFilter = reactSelect.createFilter(Object.assign({}, onlyLabelFilterSettings, {
  matchFrom: 'start'
}));
const getAvailableFilterOptions = function getAvailableFilterOptions(input, filterOptions) {
  var _input;
  if (input === void 0) {
    input = [];
  }
  const allOptions = (_input = input) === null || _input === void 0 ? void 0 : _input.map(it => {
    var _it$filterOptions$fie;
    return ((_it$filterOptions$fie = it[filterOptions.field]) === null || _it$filterOptions$fie === void 0 ? void 0 : _it$filterOptions$fie.toString()) || '';
  });
  return removeDuplicates(allOptions);
};

const onFormikChanges = (formik, field, orElse) => e => {
  formik.setErrors({});
  formik.setFieldValue(field, e != null ? e : orElse || {});
};
const onFormikTextChanges = (formik, field, orElse) => e => {
  var _ref, _ref2, _e$target$value, _e$target;
  formik.setErrors({});
  formik.setFieldValue(field, (_ref = (_ref2 = (_e$target$value = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value) != null ? _e$target$value : orElse) != null ? _ref2 : e) != null ? _ref : '');
};
const onFormikNumberChanges = (formik, field) => e => {
  var _e$target2, _e$target3;
  formik.setErrors({});
  formik.setFieldValue(field, ((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value) !== '' ? Number((_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value) : '');
};
const onFormikCheckboxChanges = (formik, field, orElse) => e => {
  var _e$target$checked, _e$target4;
  formik.setErrors({});
  formik.setFieldValue(field, (_e$target$checked = (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : _e$target4.checked) != null ? _e$target$checked : !!orElse);
};
const onFormikTrimField = function onFormikTrimField(formik, field, orElse) {
  var _formik$values$field;
  if (orElse === void 0) {
    orElse = '';
  }
  const newValue = (_formik$values$field = formik.values[field]) === null || _formik$values$field === void 0 ? void 0 : _formik$values$field.toString().trim();
  formik.setFieldValue(field, newValue || orElse);
};

const fillOnChangeCountry = (formik, country) => {
  onFormikChanges(formik, 'countrySelect')(country !== null ? country : emptyUfinetSelectOption);
  onFormikChanges(formik, 'corporateGroupSelect')(emptyUfinetSelectOption);
  onFormikChanges(formik, 'clientSelect')(emptyUfinetSelectOption);
  onFormikChanges(formik, 'contactSelect')(emptyUfinetSelectOption);
};
const fillOnCorporateGroupChange = (formik, cg) => {
  onFormikChanges(formik, 'corporateGroupSelect')(cg !== null ? cg : emptyUfinetSelectOption);
  onFormikChanges(formik, 'clientSelect')(emptyUfinetSelectOption);
  onFormikChanges(formik, 'contactSelect')(emptyUfinetSelectOption);
};
const fillOnClientChange = (formik, client) => {
  onFormikChanges(formik, 'clientSelect')(client);
  onFormikChanges(formik, 'contactSelect')(emptyUfinetSelectOption);
};

function formDataFromObject(input) {
  const formData = new FormData();
  Object.keys(input).forEach(key => {
    if (input[key]) formData.set(key, input[key]);
  });
  return formData;
}
const mkFormSchema = (shape, options) => {
  var _options$intl;
  let schema = Yup.object().shape(shape);
  if (options !== null && options !== void 0 && options.multi) schema = Yup.array().of(schema);
  if (options !== null && options !== void 0 && options.required) schema = schema.required((_options$intl = options.intl) === null || _options$intl === void 0 ? void 0 : _options$intl.formatMessage({
    id: 'ERROR.REQUIRED'
  }));else schema = schema.notRequired();
  return schema;
};

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue = functionUncurryThis(1.0.valueOf);

var $RangeError$1 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString_1(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n === Infinity) throw new $RangeError$1('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $RangeError$2 = RangeError;
var $String$5 = String;
var floor$5 = Math.floor;
var repeat = functionUncurryThis(stringRepeat);
var stringSlice$8 = functionUncurryThis(''.slice);
var nativeToFixed = functionUncurryThis(1.0.toFixed);

var pow$1 = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow$1(x, n - 1, acc * x) : pow$1(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$5(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$5(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String$5(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$2 = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
_export({ target: 'Number', proto: true, forced: FORCED$2 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError$2('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String$5(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow$1(2, 69, 1)) - 69;
      z = e < 0 ? number * pow$1(2, -e, 1) : number / pow$1(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow$1(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice$8(result, 0, k - fractDigits) + '.' + stringSlice$8(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var $TypeError$g = TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw new $TypeError$g("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$2 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$2] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;







// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = functionUncurryThisClause(''.startsWith);
var stringSlice$9 = functionUncurryThisClause(''.slice);
var min$3 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG =  !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$4(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
_export({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString_1(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$3(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString_1(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice$9(that, index, index + search.length) === search;
  }
});

const countDecimals = input => {
  var _str$split$;
  if (Math.floor(input.valueOf()) === input.valueOf()) return 0;
  let str = input.toString();
  if (str.startsWith('-')) str = str.substring(1);
  return ((_str$split$ = str.split('.')[1]) === null || _str$split$ === void 0 ? void 0 : _str$split$.length) || 0;
};
const nanToValue = input => {
  return isNaN(input) ? undefined : input;
};
const numberInRange = (minInclusive, maxExclusive) => {
  return Math.random() * (maxExclusive - minInclusive) + minInclusive;
};
const isNumeric = input => {
  return input === null || input === undefined || typeof input === 'string' && !input.trim() || typeof input === 'boolean' ? false : !isNaN(+input);
};
const numberInRangeInt = (minInclusive, maxExclusive) => {
  const min = Math.ceil(minInclusive);
  const max = Math.floor(maxExclusive);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const formatCellNumber = (data, options) => {
  const finalOptions = !options ? defaultCellNumberFormattingSettings : Object.assign({}, defaultCellNumberFormattingSettings, options);
  const isValidNumber = !isNaN(+data);
  if (!isValidNumber || !data && options !== null && options !== void 0 && options.placeholderOnZero) return finalOptions.placeholder;
  const baseNumber = +data;
  const decimalPlaces = finalOptions.figures === AUTO_FIGURES ? countDecimals(baseNumber) : finalOptions.figures;
  const formattedNumber = baseNumber === 0 ? 0 : baseNumber.toFixed(decimalPlaces);
  let formattedNumberStr = finalOptions.separators ? (+formattedNumber).toLocaleString('en-US', {
    minimumFractionDigits: Math.min(20, decimalPlaces)
  }) : formattedNumber.toString();
  if (finalOptions.percentage) formattedNumberStr += '%';
  return formattedNumberStr;
};
const defaultCellNumberFormattingSettings = {
  figures: 2,
  separators: false,
  percentage: false,
  placeholder: noContentPlaceholder
};
const AUTO_FIGURES = -1;
const tableDataFormattingSettings = {
  figures: 2,
  separators: true,
  percentage: false,
  placeholder: noContentPlaceholder
};
const tableDeadlineFormattingSettings = Object.assign({}, defaultCellNumberFormattingSettings, {
  figures: 0,
  placeholderOnZero: false
});
const tableCostsFormattingSettings = Object.assign({}, tableDataFormattingSettings, {
  placeholderOnZero: true
});
const coordinatesCellNumberFormattingSettings = Object.assign({}, defaultCellNumberFormattingSettings, {
  figures: 6,
  placeholderOnZero: true
});
const totalsFormattingSettings = {
  figures: 2,
  separators: true,
  percentage: false,
  placeholder: noContentPlaceholder
};
const countryParamsFormattingSettings = {
  figures: 2,
  separators: true,
  percentage: false,
  placeholder: noContentPlaceholder
};
const tirFormattingSettings = Object.assign({}, totalsFormattingSettings, {
  percentage: true
});
function formatFileSize(size) {
  const numericSize = size >= 1000000 ? size / 1000 / 1000 : size >= 1000 ? size / 1000 : size;
  const units = size >= 1000000 ? 'megabytes' : size >= 1000 ? 'kilobytes' : 'bytes';
  return formatCellNumber(numericSize) + " " + units;
}

function toggleFullScreen(documentElement) {
  if (!document.fullscreenElement) {
    documentElement.requestFullscreen();
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
}

function isOverflowing(element) {
  return element.parentElement ? element.getBoundingClientRect().width > element.parentElement.getBoundingClientRect().width : false;
}
const clickedOnElementById = (id, target) => {
  var _document$getElementB;
  if (!target || !id) return false;
  return ((_document$getElementB = document.getElementById(id)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.contains(target)) || false;
};

(function (LANGUAGE_CODE) {
  LANGUAGE_CODE["ENGLISH"] = "en";
  LANGUAGE_CODE["SPANISH"] = "es";
  LANGUAGE_CODE["PORTUGUESE"] = "pt";
})(exports.LANGUAGE_CODE || (exports.LANGUAGE_CODE = {}));

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
_export({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});

function curateNulls(input) {
  Object.keys(input).forEach(key => {
    if (input[key] === null) input[key] = undefined;
  });
  return input;
}
const predicateEqualsObject = (item, element) => {
  const itemParsed = Object.entries(item).map(_ref => {
    let [key, value] = _ref;
    return {
      key,
      value
    };
  });
  for (let i = 0; i < itemParsed.length; i++) {
    if (itemParsed[i].key === element[i].key && itemParsed[i].value !== element[i].value) return false;
  }
  return true;
};
const getArrayFromObject = object => {
  return Object.entries(object).map(_ref2 => {
    let [key, value] = _ref2;
    return {
      key,
      value: "" + value
    };
  });
};
const getObjectFromArray = item => {
  return Object.fromEntries(item.map(el => ["" + el.key, "" + el.value]));
};
const isEmptyObject = input => {
  if (input === null || input === undefined) return true;else return Object.values(input).every(value => !value);
};
const removeFalsyProperties = input => {
  return Object.fromEntries(Object.entries(input).filter(_ref3 => {
    let [_, v] = _ref3;
    return v !== null && v !== undefined;
  }));
};

var UNSUPPORTED_Y$3 = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$4 = Math.min;
var $push = [].push;
var exec$4 = functionUncurryThis(/./.exec);
var push$5 = functionUncurryThis($push);
var stringSlice$a = functionUncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] === 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length !== 4 ||
    'ab'.split(/(?:ab)*/).length !== 2 ||
    '.'.split(/(.?)(.?)/).length !== 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString_1(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return functionCall(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = functionCall(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$5(output, stringSlice$a(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) functionApply($push, output, arraySliceSimple(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec$4(separatorCopy, '')) push$5(output, '');
      } else push$5(output, stringSlice$a(string, lastLastIndex));
      return output.length > lim ? arraySliceSimple(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? functionCall(splitter, separator, O, limit)
        : functionCall(internalSplit, toString_1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$3 ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$3 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$3 ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y$3 ? stringSlice$a(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$4(toLength(splitter.lastIndex + (UNSUPPORTED_Y$3 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$5(A, stringSlice$a(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$5(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$5(A, stringSlice$a(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y$3);

function getCurrentUrl(pathname) {
  return pathname.split(/[?#]/)[0];
}
function checkIsActive(pathname, url) {
  const current = getCurrentUrl(pathname);
  if (!current || !url) {
    return false;
  }
  if (current === url) {
    return true;
  }
  if (current.indexOf(url) > -1) {
    return true;
  }
  return false;
}

var $TypeError$h = TypeError;

var deletePropertyOrThrow = function (O, P) {
  if (!delete O[P]) throw new $TypeError$h('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var firefox = engineUserAgent.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var test$1 = [];
var nativeSort = functionUncurryThis(test$1.sort);
var push$6 = functionUncurryThis(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 70;
  if (engineFfVersion && engineFfVersion > 3) return;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$3 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1(x) > toString_1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$3 }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$6(items, array[index]);
    }

    arraySort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

function sortAlphabetically(array, columnObject) {
  return array === null || array === void 0 ? void 0 : array.sort((a, b) => {
    if (a[columnObject] > b[columnObject]) return 1;
    if (a[columnObject] < b[columnObject]) return -1;
    return 0;
  });
}

const compareString = (in1, in2) => {
  if (!in1 || !in2) return false;
  return in1.localeCompare(in2) === 0;
};
const compareStringIgnoreCase = (in1, in2) => {
  return compareString(in1 === null || in1 === void 0 ? void 0 : in1.toLowerCase(), in2 === null || in2 === void 0 ? void 0 : in2.toLowerCase());
};
function joinValuesWithConjunctionAndSeparator(values, conjunction, separator, spaceSeparator) {
  if (conjunction === void 0) {
    conjunction = 'y';
  }
  if (separator === void 0) {
    separator = ',';
  }
  if (spaceSeparator === void 0) {
    spaceSeparator = true;
  }
  if (values.length === 0) {
    return '';
  }
  if (values.length === 1) {
    return values[0];
  }
  if (values.length === 2) {
    return values[0] + " " + conjunction + " " + values[1];
  }
  const separatorWithSpace = "" + separator + (spaceSeparator ? ' ' : '');
  const allButLast = values.slice(0, -1).join(separatorWithSpace);
  const last = values.slice(-1);
  return allButLast + " " + conjunction + " " + last;
}

function mkUrlWithSearchParams(baseUrl, params) {
  const requestUrl = new URL(baseUrl);
  if (typeof params !== 'object') return requestUrl;
  Object.entries(params).forEach(_ref => {
    let [key, value] = _ref;
    if (value != null) {
      requestUrl.searchParams.append(key, value);
    }
  });
  return requestUrl;
}

const useAqsError = () => {
  const [error, setError] = React.useState(null);
  const setAqsError = error => {
    setError(setAqsErrorHelper(error));
  };
  return [error, setAqsError];
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// Asynchronously await a promise and pass the result to a finally continuation
function _finallyRethrows(body, finalizer) {
	try {
		var result = body();
	} catch (e) {
		return finalizer(true, e);
	}
	if (result && result.then) {
		return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
	}
	return finalizer(false, result);
}

var NativePromisePrototype$2 = promiseNativeConstructor && promiseNativeConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!promiseNativeConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype$2['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
_export({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if ( isCallable(promiseNativeConstructor)) {
  var method$1 = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype$2['finally'] !== method$1) {
    defineBuiltIn(NativePromisePrototype$2, 'finally', method$1, { unsafe: true });
  }
}

function useDeepCompareMemoize(value) {
  const ref = React.useRef();
  if (!fastEquals.deepEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}
function useDeepEffect(callback, deps) {
  if (deps === void 0) {
    deps = [];
  }
  React.useEffect(callback, deps.map(useDeepCompareMemoize));
}

function useAsync(_ref, deps) {
  let {
    asyncFn,
    onSuccess,
    onFailure,
    runFinally,
    options
  } = _ref;
  if (deps === void 0) {
    deps = [];
  }
  const effectFunction = options !== null && options !== void 0 && options.deep ? useDeepEffect : React.useEffect;
  const didMountRef = React.useRef(false);
  effectFunction(() => {
    if (options !== null && options !== void 0 && options.skipMount && didMountRef.current === false) {
      didMountRef.current = true;
      return;
    }
    let isActive = true;
    asyncFn().then(data => {
      if (isActive) onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
      return data;
    }).catch(err => {
      if (isActive) {
        if (onFailure) onFailure(err);else throw err;
      }
    }).finally(() => {
      if (isActive) runFinally === null || runFinally === void 0 ? void 0 : runFinally();
    });
    return () => {
      isActive = false;
    };
  }, [...deps]);
  return function () {
    try {
      const _temp = _finallyRethrows(function () {
        return _catch(function () {
          return Promise.resolve(asyncFn()).then(function (result) {
            if (onSuccess) onSuccess(result);
          });
        }, function (err) {
          if (onFailure) onFailure(err);
        });
      }, function (_wasThrown, _result) {
        if (runFinally) runFinally();
        if (_wasThrown) throw _result;
        return _result;
      });
      return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const useDebouncedCallback = (callback, delay, options) => {
  const callbackRef = React.useRef();
  callbackRef.current = callback;
  return React.useCallback(debounce(function () {
    return callbackRef.current && callbackRef.current(...arguments);
  }, delay, options), []);
};

const defaultOptions = {
  events: ['click'],
  detection: 'inside',
  conditions: [],
  conditionsOverride: true,
  allConditionsRequired: true
};
function useDOMEvent(ref, callback, options) {
  if (options === void 0) {
    options = defaultOptions;
  }
  React.useEffect(() => {
    function handleDOMEvent(event) {
      var _options$conditions, _ref$current;
      const conditionsResults = (_options$conditions = options.conditions) === null || _options$conditions === void 0 ? void 0 : _options$conditions.map(condition => condition(ref.current || undefined, event));
      const conditionsMet = conditionsResults === undefined || (options.allConditionsRequired ? conditionsResults.every(r => r) : conditionsResults.some(r => r));
      const eventInside = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(event.target);
      const shouldRun = options.conditionsOverride ? conditionsMet || ref.current && options.detection === 'outside' && !eventInside || options.detection === 'inside' && eventInside : conditionsMet && ref.current && options.detection === 'outside' && !eventInside || options.detection === 'inside' && eventInside;
      if (shouldRun) {
        event.preventDefault();
        callback(event);
      }
    }
    options.events.forEach(event => document.addEventListener(event, handleDOMEvent));
    return () => {
      options.events.forEach(event => document.removeEventListener(event, handleDOMEvent));
    };
  }, [callback, options.allConditionsRequired, options.conditions, options.conditionsOverride, options.detection, options.events, ref]);
}

const useInternalUser = () => {
  const authData = React.useContext(AuthContext);
  const internalUser = React.useMemo(() => {
    var _authData$userData;
    return ((_authData$userData = authData.userData) === null || _authData$userData === void 0 ? void 0 : _authData$userData.user.type) === exports.UserTypesEnum.INTERNAL_USER;
  }, [authData]);
  return internalUser;
};

const useInViewport = () => {
  const [isInViewport, setIsInViewport] = React.useState(false);
  const [refElement, setRefElement] = React.useState(null);
  const setRef = React.useCallback(node => {
    if (node !== null) {
      setRefElement(node);
    }
  }, []);
  React.useEffect(() => {
    if (refElement && !isInViewport) {
      const observer = new IntersectionObserver(_ref => {
        let [entry] = _ref;
        return entry.isIntersecting && setIsInViewport(true);
      });
      observer.observe(refElement);
      return () => {
        observer.disconnect();
      };
    }
  }, [isInViewport, refElement]);
  return {
    isInViewport,
    ref: setRef
  };
};

const useListener = (eventId, onDataChange) => {
  React.useEffect(() => {
    if (eventId) {
      window.addEventListener(eventId, onDataChange);
    }
    return () => {
      if (eventId) {
        window.removeEventListener(eventId, onDataChange);
      }
    };
  }, [eventId, onDataChange]);
};

const useLoading = () => {
  const [loading, setLoading] = React.useState(false);
  const startLoading = React.useCallback(() => {
    setLoading(true);
  }, []);
  const stopLoading = React.useCallback(() => {
    setLoading(false);
  }, []);
  return {
    loading,
    startLoading,
    stopLoading
  };
};

function useLongPress(_temp) {
  let {
    onClick = e => {},
    onLongPress = e => {},
    ms = 300
  } = _temp === void 0 ? {} : _temp;
  const timerRef = React.useRef();
  const eventRef = React.useRef();
  const callback = React.useCallback(() => {
    onLongPress(eventRef.current);
    eventRef.current = undefined;
    timerRef.current = undefined;
  }, [onLongPress]);
  const start = React.useCallback(ev => {
    ev.persist();
    eventRef.current = ev;
    timerRef.current = setTimeout(callback, ms);
  }, [callback, ms]);
  const stop = React.useCallback(ev => {
    ev.persist();
    eventRef.current = ev;
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      onClick(eventRef.current);
      timerRef.current = undefined;
      eventRef.current = undefined;
    }
  }, [onClick]);
  return React.useMemo(() => ({
    onMouseDown: start,
    onMouseUp: stop,
    onMouseLeave: stop,
    onTouchStart: start,
    onTouchEnd: stop
  }), [start, stop]);
}

const useModal = () => {
  const [modal, setModal] = React.useState(false);
  const show = () => {
    setModal(true);
  };
  const hide = React.useCallback(() => {
    setModal(false);
  }, []);
  return [modal, show, hide];
};

const useSelectClear = () => {
  const [value, setValue] = React.useState(false);
  const clearValue = () => {
    setValue(!value);
  };
  return [value, clearValue];
};

const useTranslator = () => {
  const intl = reactIntl.useIntl();
  const translate = React.useCallback((key, values) => intl.formatMessage({
    id: key
  }, Object.assign({}, values)), [intl]);
  return translate;
};

const useUserDomain = () => {
  const authData = React.useContext(AuthContext);
  const userDomain = React.useMemo(() => {
    try {
      var _authData$userData;
      return parseDomainFromEmail((_authData$userData = authData.userData) === null || _authData$userData === void 0 ? void 0 : _authData$userData.username);
    } catch (e) {
      return undefined;
    }
  }, [authData]);
  return userDomain;
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) === 'Array';
};

var push$7 = functionUncurryThis([].push);

var getJsonReplacerFunction = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push$7(keys, element);
    else if (typeof element == 'number' || classofRaw(element) === 'Number' || classofRaw(element) === 'String') push$7(keys, toString_1(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

var $String$6 = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec$5 = functionUncurryThis(/./.exec);
var charAt$8 = functionUncurryThis(''.charAt);
var charCodeAt$2 = functionUncurryThis(''.charCodeAt);
var replace$8 = functionUncurryThis(''.replace);
var numberToString$1 = functionUncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getJsonReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = functionCall($replacer, this, $String$6(key), value);
    if (!isSymbol(value)) return value;
  };
  return functionApply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt$8(string, offset - 1);
  var next = charAt$8(string, offset + 1);
  if ((exec$5(low, match) && !exec$5(hi, next)) || (exec$5(hi, match) && !exec$5(low, prev))) {
    return '\\u' + numberToString$1(charCodeAt$2(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  _export({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = functionApply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$8(result, tester, fixIllFormed) : result;
    }
  });
}

function setLanguage(lang) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({
    selectedLang: lang
  }));
  window.location.reload();
}
function getConfig() {
  const ls = localStorage.getItem(I18N_CONFIG_KEY);
  if (ls) {
    try {
      return JSON.parse(ls);
    } catch (er) {
      console.error(er);
    }
  }
  return i18nInitialState;
}
const useLang = () => {
  const i18nProps = React.useContext(I18nContext);
  return i18nProps.selectedLang;
};
const getTranslation = (intl, key, values) => intl.formatMessage({
  id: key
}, values);

function getNotificationTranslation(value, intl) {
  const intlKey = NotificationTranslations.get(value);
  return intlKey ? intl.formatMessage({
    id: intlKey
  }) : value;
}
const successNotifications = {
  createRegistry: (intl, target) => intl.formatMessage({
    id: 'GENERIC.REGISTRY.CREATE.SUCCESS'
  }, {
    target
  }),
  createArea: (intl, values) => intl.formatMessage({
    id: 'COUNTRY.AREA.REGISTRY.NEW.SUCCESS'
  }, values),
  updateRegistry: (intl, target) => intl.formatMessage({
    id: 'GENERIC.REGISTRY.UPDATE.SUCCESS'
  }, {
    target
  }),
  updateArea: (intl, values) => intl.formatMessage({
    id: 'COUNTRY.AREA.REGISTRY.UPDATE.SUCCESS'
  }, values),
  deleteOne: (intl, values) => intl.formatMessage({
    id: 'SECTION.DELETE.INDIVIDUAL.SUCCESS'
  }, values),
  deleteById: (intl, values) => intl.formatMessage({
    id: 'SECTION.DELETE.INDIVIDUAL.SUCCESS.WITH_ID'
  }, values),
  deleteByIdsList: (intl, values) => intl.formatMessage({
    id: 'SECTION.DELETE.MASSIVE.SUCCESS'
  }, values),
  downloadXLS: (intl, values) => intl.formatMessage({
    id: 'COUNTRY.AREA.DOWNLOAD.SUCCESS'
  }, {
    countries: values.countries.join(', '),
    areas: values.areas.join(', '),
    section: values.section
  }),
  downloadEmptyListXLS: (intl, values) => intl.formatMessage({
    id: 'COUNTRY.AREA.DOWNLOAD.EMPTY.SUCCESS'
  }, values),
  downloadClientTemplateXLS: (intl, values) => intl.formatMessage({
    id: 'CLIENT.DOWNLOAD.SUCCESS'
  }, values),
  uploadSectionXLS: (intl, values) => intl.formatMessage({
    id: 'XLS.SECTION.UPLOAD.SUCCESS'
  }, values),
  uploadMassiveQuotationXLS: intl => intl.formatMessage({
    id: 'XLS.QUOTATION.MASSIVE.UPLOAD.SUCCESS'
  })
};
function notificationParty(autoClose) {
  const [types, positions] = [['info', 'warning', 'error', 'success'], ['top-left', 'top-right', 'bottom-left', 'bottom-right']];
  const zipped = types.map((text, idx) => {
    return [text, positions[idx]];
  });
  for (const x of zipped) {
    reactToastify.toast('¡ALPACA TIME!', {
      autoClose,
      position: x[1],
      type: x[0]
    });
  }
}

var $includes = arrayIncludes.includes;



// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

const defaultOptionsFetch = {
  fileResponse: false,
  notification: undefined,
  notificationType: 'success',
  notifyError: true,
  notifyWithMessage: true,
  authenticationData: InitialAuthData,
  sendAuth: true,
  apiKey: process.env.REACT_APP_API_KEY,
  sendApiKey: false,
  signal: undefined
};
const silentFailureOptionsFetch = {
  notifyError: false
};
const authorizationHeaders = authData => {
  var _authData$token;
  return !(authData !== null && authData !== void 0 && (_authData$token = authData.token) !== null && _authData$token !== void 0 && _authData$token.accessToken) ? {} : {
    Authorization: "Bearer " + authData.token.accessToken
  };
};
const apiKeyHeaders = apiKey => {
  return !apiKey ? {} : {
    apiKey: apiKey
  };
};
const acceptHeaders = {
  Accept: 'application/json',
  'Access-Control-Expose-Headers': 'Content-Disposition'
};
const contentTypeHeaders = {
  'Content-Type': 'application/json',
  'Access-Control-Expose-Headers': 'Content-Disposition'
};
const acceptAndContentTypeHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Expose-Headers': 'Content-Disposition'
};
const buildHeaders = (method, auth, apiKey, signal) => ({
  method,
  headers: Object.assign({}, contentTypeHeaders, authorizationHeaders(auth), apiKeyHeaders(apiKey)),
  signal
});
const buildHeadersWithBody = (method, body, auth, apiKey, signal) => ({
  method,
  headers: Object.assign({}, acceptHeaders, authorizationHeaders(auth), apiKeyHeaders(apiKey)),
  body,
  signal
});
const buildHeadersWithJsonBody = (method, body, auth, apiKey, signal) => ({
  method,
  headers: Object.assign({}, acceptAndContentTypeHeaders, authorizationHeaders(auth), apiKeyHeaders(apiKey)),
  body,
  signal
});
const manageResponse = function manageResponse(options) {
  if (options === void 0) {
    options = defaultOptionsFetch;
  }
  return function (response) {
    try {
      if (!response.ok) {
        return Promise.resolve(response.json()).then(function (errorObj) {
          throw Object.assign({}, errorObj, {
            statusCode: response.status
          });
        });
      } else {
        const toastOptions = {
          autoClose: options.notificationDurationSuccess,
          containerId: TOAST_CONTAINER_ID
        };
        if (options.notification) {
          switch (options.notificationType) {
            case 'success':
              reactToastify.toast.success(options.notification, toastOptions);
              break;
            case 'error':
              reactToastify.toast.error(options.notification, toastOptions);
              break;
            case 'warn':
              reactToastify.toast.warn(options.notification, toastOptions);
              break;
            default:
              reactToastify.toast.info(options.notification, toastOptions);
          }
        }
        return Promise.resolve(options.fileResponse ? response : response.json().catch(() => ''));
      }
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
function manageError(error, options) {
  const {
    statusCode,
    message,
    errors
  } = error;
  const notificationTitle = typeof options.notifyWithMessage === 'string' ? options.notifyWithMessage : options.notifyWithMessage === true ? message : undefined;
  const notificationBody = [errors].filter(Boolean).join('. ');
  const notificationContent = /*#__PURE__*/React__default.createElement("div", {
    className: "d-flex flex-column justify-content-center"
  }, (notificationTitle === null || notificationTitle === void 0 ? void 0 : notificationTitle.trim()) && /*#__PURE__*/React__default.createElement("h6", {
    className: "mb-0"
  }, notificationTitle), typeof notificationBody === 'string' && notificationBody.trim() ? /*#__PURE__*/React__default.createElement("p", {
    className: "mb-0"
  }, notificationBody) : /*#__PURE__*/React__default.createElement("div", null, notificationBody));
  options.notifyError && reactToastify.toast.dismiss();
  const toastOptions = {
    autoClose: options.notificationDurationError,
    containerId: TOAST_CONTAINER_ID
  };
  if (statusCode === 400) {
    options.notifyError && reactToastify.toast.warn(notificationContent, toastOptions);
  } else if ([401, 403].includes(statusCode)) {
    var _options$authenticati;
    options.notifyError && reactToastify.toast.error(notificationContent, toastOptions);
    (_options$authenticati = options.authenticationData) === null || _options$authenticati === void 0 ? void 0 : _options$authenticati.logout();
  } else if (statusCode > 400 && statusCode < 600) {
    options.notifyError && reactToastify.toast.error(notificationContent, toastOptions);
  }
  throw error;
}
function processFetch(promise, options) {
  if (options === void 0) {
    options = defaultOptionsFetch;
  }
  return promise.then(manageResponse(options)).catch(err => manageError(err, options));
}
const FetchAPI = {
  get: function get(url, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(url, buildHeaders('GET', options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  get_params: function get_params(url, params, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(mkUrlWithSearchParams(url, params), buildHeaders('GET', options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined, options.signal)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  post: function post(url, data, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(mkUrlWithSearchParams(url, options.queryParameters), buildHeadersWithJsonBody('POST', JSON.stringify(data), options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined, options.signal)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  post_formdata: function post_formdata(url, body, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(mkUrlWithSearchParams(url, options.queryParameters), buildHeadersWithBody('POST', body, options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined, options.signal)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  patch: function patch(url, data, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(mkUrlWithSearchParams(url, options.queryParameters), buildHeadersWithJsonBody('PATCH', JSON.stringify(data), options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined, options.signal)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  patch_formdata: function patch_formdata(url, body, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(url, buildHeadersWithBody('PATCH', body, options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  delete: function _delete(url, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(url, buildHeaders('DELETE', options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined, options.signal)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  deleteWithBody: function deleteWithBody(url, data, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(url, buildHeadersWithJsonBody('DELETE', JSON.stringify(data), options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined, options.signal)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  put: function put(url, data, options) {
    if (options === void 0) {
      options = defaultOptionsFetch;
    }
    try {
      return Promise.resolve(processFetch(fetch(url, buildHeadersWithJsonBody('PUT', JSON.stringify(data), options.sendAuth ? options.authenticationData : undefined, options.sendApiKey ? options.apiKey : undefined, options.signal)), options));
    } catch (e) {
      return Promise.reject(e);
    }
  }
};

const url = process.env.REACT_APP_URL_BACK_AQS + "api/network/area";
const kmzAreaService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  const urlKmz = url + "/kmz";
  return {
    uploadKmz: function (data) {
      try {
        return Promise.resolve(FetchAPI.post_formdata("" + urlKmz, data, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    confirmKmz: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(urlKmz + "/confirm", data, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    uploadKmzToUpdateArea: function (areaId, data) {
      try {
        return Promise.resolve(FetchAPI.post_formdata(urlKmz + "/" + areaId, data, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    confirmKmzToUpdateArea: function (areaId, data) {
      try {
        return Promise.resolve(FetchAPI.post(urlKmz + "/" + areaId + "/confirm", data, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};
const typesAreaService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  const urlTypes = url + "/types";
  return {
    getAllNetworkTypes: function () {
      try {
        return Promise.resolve(FetchAPI.get(urlTypes, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};
const areaService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findArea: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(url + "/find", data, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteArea: function (areaId) {
      try {
        return Promise.resolve(FetchAPI.delete(url + "/" + areaId, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteById(intl, {
            id: areaId,
            section: intl.formatMessage({
              id: 'SECTION.AREAS'
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteByIdsList: function (areaIds) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody("" + url, areaIds, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteByIdsList(intl, {
            section: intl.formatMessage({
              id: 'SECTION.AREAS'
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    updateArea: function (areaId, data) {
      try {
        return Promise.resolve(FetchAPI.put(url + "/" + areaId, {
          name: data.name,
          networkAccessAreaStatus: data.networkAccessAreaStatus,
          visible: data.visible
        }, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.updateArea(intl, {
            country: data.countryName,
            area: data.name
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

function getAreaStatusTranslation(value, intl) {
  const intlKey = areaStatusToText.get(value || exports.AreaAccessStatus.NOT_CONNECTED);
  return intlKey ? intl.formatMessage({
    id: intlKey
  }) : value;
}

const url$1 = process.env.REACT_APP_URL_BACK_AQS + "api/bandwidth";
const bandwidthsService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findByOriginCountryAndDestinationCountryAndClientIdAndProductId: function (bandwidthRequest, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$1 + "/find", bandwidthRequest, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const makeBandwidthLabel = (bandwidth, units) => {
  if (!bandwidth || !units) return '-';
  return formatCellNumber(bandwidth, {
    figures: AUTO_FIGURES,
    placeholder: '-'
  }) + " " + unitMappings.get(units);
};
const makeSelectOptionFromBandwidth = _ref => {
  let {
    id,
    capacity,
    bandwidth,
    unit
  } = _ref;
  return {
    value: id,
    label: bandwidth ? bandwidth + " " + unitMappings.get(unit) : capacity + " " + unitMappings.get(exports.BandwidthUnits.MBPS),
    capacity,
    bandwidth,
    unit
  };
};

const urlBuildingAccess = process.env.REACT_APP_URL_BACK_AQS + "api/cost/access";
const BUILDING_ACCESS_COST = 'BUILDING_ACCESS.COSTS';
const buildingAccessCostsService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findByCriteria: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(urlBuildingAccess + "/find", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: function (cost) {
      try {
        return Promise.resolve(FetchAPI.post("" + urlBuildingAccess, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.createArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    update: function (costId, cost) {
      try {
        return Promise.resolve(FetchAPI.put(urlBuildingAccess + "/" + costId, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.updateArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteByIdsList: function (costsIds) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody(urlBuildingAccess + "/", costsIds, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteByIdsList(intl, {
            section: intl.formatMessage({
              id: BUILDING_ACCESS_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteById: function (id) {
      try {
        return Promise.resolve(FetchAPI.delete(urlBuildingAccess + "/" + id, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteById(intl, {
            id,
            section: intl.formatMessage({
              id: BUILDING_ACCESS_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.put(urlBuildingAccess + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadXLS(intl, {
            countries: data.countries,
            areas: data.networkAreas,
            section: intl.formatMessage({
              id: BUILDING_ACCESS_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadEmptyListXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(urlBuildingAccess + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadEmptyListXLS(intl, {
            section: intl.formatMessage({
              id: BUILDING_ACCESS_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    uploadXLS: function (body) {
      try {
        return Promise.resolve(FetchAPI.post_formdata(urlBuildingAccess + "/xls/upload", body, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.uploadSectionXLS(intl, {
            section: intl.formatMessage({
              id: BUILDING_ACCESS_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const urlEconomicModel = process.env.REACT_APP_URL_BACK_AQS + "api/cost/economicmodel";
const ECONOMIC_MODEL_COST = 'ECONOMIC_MODEL.COSTS';
const economicModelCostsService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findByCriteria: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(urlEconomicModel + "/find", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: function (cost) {
      try {
        return Promise.resolve(FetchAPI.post("" + urlEconomicModel, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.createArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    update: function (costId, cost) {
      try {
        return Promise.resolve(FetchAPI.put(urlEconomicModel + "/" + costId, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.updateArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteByIdsList: function (costsIds) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody(urlEconomicModel + "/", costsIds, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteByIdsList(intl, {
            section: intl.formatMessage({
              id: ECONOMIC_MODEL_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteById: function (id) {
      try {
        return Promise.resolve(FetchAPI.delete(urlEconomicModel + "/" + id, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteById(intl, {
            id,
            section: intl.formatMessage({
              id: ECONOMIC_MODEL_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.put(urlEconomicModel + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadXLS(intl, {
            countries: data.countries,
            areas: data.networkAreas,
            section: intl.formatMessage({
              id: ECONOMIC_MODEL_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadEmptyListXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(urlEconomicModel + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadEmptyListXLS(intl, {
            section: intl.formatMessage({
              id: ECONOMIC_MODEL_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    uploadXLS: function (body) {
      try {
        return Promise.resolve(FetchAPI.post_formdata(urlEconomicModel + "/xls/upload", body, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.uploadSectionXLS(intl, {
            section: intl.formatMessage({
              id: ECONOMIC_MODEL_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const urlEquipment = process.env.REACT_APP_URL_BACK_AQS + "api/cost/equipment";
const EQUIPMENT_COST = 'EQUIPMENT.COSTS';
const equipmentCostsService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findByCriteria: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(urlEquipment + "/find", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: function (cost) {
      try {
        return Promise.resolve(FetchAPI.post("" + urlEquipment, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.createArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    update: function (costId, cost) {
      try {
        return Promise.resolve(FetchAPI.put(urlEquipment + "/" + costId, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.updateArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteByIdsList: function (costsIds) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody("" + urlEquipment, costsIds, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteByIdsList(intl, {
            section: intl.formatMessage({
              id: EQUIPMENT_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteById: function (id) {
      try {
        return Promise.resolve(FetchAPI.delete(urlEquipment + "/" + id, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteById(intl, {
            id,
            section: intl.formatMessage({
              id: EQUIPMENT_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.put(urlEquipment + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadXLS(intl, {
            countries: data.countries,
            areas: data.networkAreas,
            section: intl.formatMessage({
              id: EQUIPMENT_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadEmptyListXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(urlEquipment + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadEmptyListXLS(intl, {
            section: intl.formatMessage({
              id: EQUIPMENT_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    uploadXLS: function (body) {
      try {
        return Promise.resolve(FetchAPI.post_formdata(urlEquipment + "/xls/upload", body, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.uploadSectionXLS(intl, {
            section: intl.formatMessage({
              id: EQUIPMENT_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const urlFO = process.env.REACT_APP_URL_BACK_AQS + "api/cost/construction";
const FO_COST = 'FO.COSTS';
const foCostsService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findByCriteria: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(urlFO + "/find", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: function (cost) {
      try {
        return Promise.resolve(FetchAPI.post("" + urlFO, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.createArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    update: function (costId, cost) {
      try {
        return Promise.resolve(FetchAPI.put(urlFO + "/" + costId, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.updateArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteByIdsList: function (costsIds) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody("" + urlFO, costsIds, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteByIdsList(intl, {
            section: intl.formatMessage({
              id: FO_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteById: function (id) {
      try {
        return Promise.resolve(FetchAPI.delete(urlFO + "/" + id, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteById(intl, {
            id,
            section: intl.formatMessage({
              id: FO_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.put(urlFO + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadXLS(intl, {
            countries: data.countries,
            areas: data.networkAreas,
            section: intl.formatMessage({
              id: FO_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadEmptyListXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(urlFO + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadEmptyListXLS(intl, {
            section: intl.formatMessage({
              id: FO_COST
            })
          }),
          notificationType: 'success'
        })).then(response => browserDownload(response)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    uploadXLS: function (body) {
      try {
        return Promise.resolve(FetchAPI.post_formdata(urlFO + "/xls/upload", body, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.uploadSectionXLS(intl, {
            section: intl.formatMessage({
              id: FO_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const urlInfrastructure = process.env.REACT_APP_URL_BACK_AQS + "api/cost/infrastructure";
const INFRA_COST = 'INFRASTRUCTURE.COSTS';
const infrastructureCostsService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findByCriteria: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(urlInfrastructure + "/find", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: function (cost) {
      try {
        return Promise.resolve(FetchAPI.post("" + urlInfrastructure, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.createArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    update: function (costId, cost) {
      try {
        return Promise.resolve(FetchAPI.put(urlInfrastructure + "/" + costId, cost, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.updateArea(intl, {
            country: cost.countryName,
            area: cost.networkAreaName
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteByIdsList: function (costsIds) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody(urlInfrastructure + "/", costsIds, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteByIdsList(intl, {
            section: intl.formatMessage({
              id: INFRA_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteById: function (id) {
      try {
        return Promise.resolve(FetchAPI.delete(urlInfrastructure + "/" + id, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.deleteById(intl, {
            id,
            section: intl.formatMessage({
              id: INFRA_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.put(urlInfrastructure + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadXLS(intl, {
            countries: data.countries,
            areas: data.networkAreas,
            section: intl.formatMessage({
              id: INFRA_COST
            })
          }),
          notificationType: 'success'
        })).then(browserDownload));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    downloadEmptyListXLS: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(urlInfrastructure + "/xls/download", data, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadEmptyListXLS(intl, {
            section: intl.formatMessage({
              id: INFRA_COST
            })
          }),
          notificationType: 'success'
        })).then(browserDownload));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    uploadXLS: function (body) {
      try {
        return Promise.resolve(FetchAPI.post_formdata(urlInfrastructure + "/xls/upload", body, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.uploadSectionXLS(intl, {
            section: intl.formatMessage({
              id: INFRA_COST
            })
          }),
          notificationType: 'success'
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$2 = process.env.REACT_APP_URL_BACK_AQS + "api/countries/params";
const countryParamsService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    getAllCountryParams: function (options) {
      try {
        return Promise.resolve(FetchAPI.get(url$2, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    findById: function (id, options) {
      try {
        return Promise.resolve(FetchAPI.get(url$2 + "/" + id, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    findByCountryId: function (request, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$2 + "/find", request, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    createCountryParams: function (request, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$2, request, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    updateCountryParams: function (request, options) {
      try {
        return Promise.resolve(FetchAPI.put(url$2 + "/" + request.id, request, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteSingleCountryParams: function (id, options) {
      try {
        return Promise.resolve(FetchAPI.delete(url$2 + "/" + id, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteManyCountryParams: function (request, options) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody(url$2, request, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$3 = process.env.REACT_APP_URL_BACK_AQS + "api/network/area/geojson";
const kmzAreasService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findArea: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(url$3 + "/find", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$4 = process.env.REACT_APP_URL_BACK_AQS + "api/network/kmz/files";
const kmzFilesService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findFile: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(url$4 + "/find", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$5 = process.env.REACT_APP_URL_BACK_AQS + "api/network/item/kmz";
const kmzItemsService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    uploadKmz: function (body) {
      try {
        return Promise.resolve(FetchAPI.post_formdata("" + url$5, body, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    confirm: function (data) {
      try {
        return Promise.resolve(FetchAPI.post(url$5 + "/confirm", data, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$6 = process.env.REACT_APP_URL_BACK_AQS + "api/network/item";
const networkItemsService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    getAllNetworkTypes: function () {
      try {
        return Promise.resolve(FetchAPI.get(url$6 + "/types", fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$7 = process.env.REACT_APP_URL_BACK_AQS + "api/pop";
const popService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    findPopsByCountryId: function (popRequest) {
      try {
        return Promise.resolve(FetchAPI.post(url$7 + "/findCountry", popRequest, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    findPopsByCorporateGroupId: function (popRequest) {
      try {
        return Promise.resolve(FetchAPI.post(url$7 + "/findCorporate", popRequest, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    findPopsByCountryIdAndCorporateGroupId: function (popRequest) {
      try {
        return Promise.resolve(FetchAPI.post(url$7 + "/findCountryAndCorporate", popRequest, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$8 = process.env.REACT_APP_URL_BACK_AQS + "api/product";
const productsService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    getAllProducts: function () {
      try {
        return Promise.resolve(FetchAPI.get("" + url$8, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$9 = process.env.REACT_APP_URL_BACK_AQS + "api/quotation/bulk";
const urlXls = url$9 + "/xls";
const bulkQuotationService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    find: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.get(url$9 + "/" + criteria.bulkId, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    findAll: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$9 + "/find", criteria, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};
const bulkQuotationXlsService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    upload: function (criteria, options) {
      try {
        const formData = formDataFromObject(criteria);
        return Promise.resolve(FetchAPI.post_formdata(urlXls + "/upload", formData, Object.assign({}, fetchOptions, {
          notification: intl && successNotifications.uploadMassiveQuotationXLS(intl),
          notificationType: 'success',
          notificationDurationError: TIMEOUT_BULK_ERROR_NOTIFICATION
        }, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    download: function (criteria, clientName, options) {
      try {
        return Promise.resolve(FetchAPI.post(urlXls + "/download", criteria, Object.assign({}, fetchOptions, {
          fileResponse: true,
          notification: intl && successNotifications.downloadClientTemplateXLS(intl, {
            clientName
          }),
          notificationType: 'success'
        }, options)).then(browserDownload));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const quotationRequestFromServicesModel = (aqsId, services, calculateInBothContexts) => {
  if (!(services !== null && services !== void 0 && services.length)) throw new Error('No services in project');
  const req = {
    aqsId,
    calculateInBothContexts,
    clientId: services[0].clientSelect.value
  };
  return req;
};

const url$a = process.env.REACT_APP_URL_BACK_AQS + "api/quotation";
const quotationService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    calculateQuotation: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$a + "/calculateProject", criteria, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    confirmQuotation: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$a + "/confirm", criteria, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    calculateOfferStatus: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$a + "/projectStatus", criteria, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

var trim = stringTrim.trim;


var $parseInt = global_1.parseInt;
var Symbol$2 = global_1.Symbol;
var ITERATOR$8 = Symbol$2 && Symbol$2.iterator;
var hex = /^[+-]?0x/i;
var exec$6 = functionUncurryThis(hex.exec);
var FORCED$4 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$8 && !fails(function () { $parseInt(Object(ITERATOR$8)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$4 ? function parseInt(string, radix) {
  var S = trim(toString_1(string));
  return $parseInt(S, (radix >>> 0) || (exec$6(hex, S) ? 16 : 10));
} : $parseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt !== numberParseInt }, {
  parseInt: numberParseInt
});

const isValidLatitude = lat => {
  return !!lat && !isNaN(+lat) && +lat >= -90 && +lat <= 90;
};
const isValidLongitude = lng => {
  return !!lng && !isNaN(+lng) && +lng >= -180 && +lng <= 180;
};
const isValidCoordinate = coord => {
  if (isValidLatitude(coord.lat) && isValidLongitude(coord.lng)) return {
    lat: +coord.lat,
    lng: +coord.lng
  };
  return null;
};
const serviceCalculateRequestFromServiceModel = (aqsId, service, calculateInBothContexts) => {
  var _service$clientSelect;
  const req = {
    temporaryId: service.temporaryId,
    aqsId,
    calculateInBothContexts,
    clientId: (_service$clientSelect = service.clientSelect) === null || _service$clientSelect === void 0 ? void 0 : _service$clientSelect.value,
    service: serviceCalculateRequestModelFromStateService(service)
  };
  return req;
};
const serviceUpdateRequestFromServiceModel = (aqsId, updatedService, preUpdatedService, calculateInBothContexts) => {
  const req = {
    id: updatedService.id,
    aqsId,
    calculateInBothContexts,
    service: serviceUpdateRequestModelFromStateService(updatedService)
  };
  return req;
};
const serviceCalculateRequestModelFromStateService = service => {
  var _service$destinationP, _service$originPopSel, _service$destinationP2;
  return {
    origin: service.serviceTypeSelect.value === exports.ProductId.INTERNET || service.serviceTypeSelect.value === exports.ProductId.COLOCATION_ID || service.serviceTypeSelect.value === exports.ProductId.TOWERING_ID || service.serviceTypeSelect.value === exports.ProductId.ENERGIA_ID || service.serviceTypeSelect.value === exports.ProductId.EQUIPO_ID || service.serviceTypeSelect.value === exports.ProductId.INFRAESTRUCTURA_ID || service.serviceTypeSelect.value === exports.ProductId.OUTSOURCING_ID || service.serviceTypeSelect.value === exports.ProductId.PUNTUAL_ID || service.serviceTypeSelect.value === exports.ProductId.VSAT_ID && true ? (_service$destinationP = service.destinationPopSelect) !== null && _service$destinationP !== void 0 && _service$destinationP.value ? new QuotationPointPop(service.destinationPopSelect.value) : new QuotationPointCoordinates({
      latitude: service.destinationLatitude,
      longitude: service.destinationLongitude
    }, service.destinationSite) : (_service$originPopSel = service.originPopSelect) !== null && _service$originPopSel !== void 0 && _service$originPopSel.value ? new QuotationPointPop(service.originPopSelect.value) : new QuotationPointCoordinates({
      latitude: service.originLatitude,
      longitude: service.originLongitude
    }, service.originSite),
    destination: (_service$destinationP2 = service.destinationPopSelect) !== null && _service$destinationP2 !== void 0 && _service$destinationP2.value ? new QuotationPointPop(service.destinationPopSelect.value) : new QuotationPointCoordinates({
      latitude: service.destinationLatitude,
      longitude: service.destinationLongitude
    }, service.destinationSite),
    product: service.product || serviceProductFromStateService(service),
    period: service.deadline
  };
};
const serviceUpdateRequestModelFromStateService = (updatedService, preUpdatedService) => {
  return {
    id: updatedService.id,
    product: updatedService.product,
    period: updatedService.deadlineUpdated,
    nrc: updatedService.nrcAdjustment,
    mrc: updatedService.mrcAdjustment,
    status: updatedService.status
  };
};
const serviceProductFromStateService = service => {
  var _service$redundancySe, _service$transmission, _service$accessSelect, _service$oversubscrip, _service$technologySe, _service$redundancySe2, _service$transmission2, _service$standardSele, _service$subStandardS;
  const invalidServiceDataType = 'Invalid service data for type';
  switch (service.serviceTypeSelect.value) {
    case exports.ProductId.INTERNET:
      return new QuotationProductInternet(service.serviceTypeSelect.value, service.bandwidthSelect.bandwidth, unitMappings.get(service.bandwidthSelect.unit), service.bandwidthSelect.unit, (_service$redundancySe = service.redundancySelect) === null || _service$redundancySe === void 0 ? void 0 : _service$redundancySe.value, (_service$transmission = service.transmissionSelect) === null || _service$transmission === void 0 ? void 0 : _service$transmission.value, (_service$accessSelect = service.accessSelect) === null || _service$accessSelect === void 0 ? void 0 : _service$accessSelect.value, (_service$oversubscrip = service.oversubscriptionSelect) === null || _service$oversubscrip === void 0 ? void 0 : _service$oversubscrip.value);
    case exports.ProductId.ELINE:
      return new QuotationProductEline(service.serviceTypeSelect.value, service.bandwidthSelect.bandwidth, unitMappings.get(service.bandwidthSelect.unit), service.bandwidthSelect.unit, service.transportLayerSelect.value, (_service$technologySe = service.technologySelect) === null || _service$technologySe === void 0 ? void 0 : _service$technologySe.value, (_service$redundancySe2 = service.redundancySelect) === null || _service$redundancySe2 === void 0 ? void 0 : _service$redundancySe2.value, (_service$transmission2 = service.transmissionSelect) === null || _service$transmission2 === void 0 ? void 0 : _service$transmission2.value, (_service$standardSele = service.standardSelect) === null || _service$standardSele === void 0 ? void 0 : _service$standardSele.value, (_service$subStandardS = service.subStandardSelect) === null || _service$subStandardS === void 0 ? void 0 : _service$subStandardS.value);
    case exports.ProductId.FIBRA_OSCURA_ID:
      if (!service.darkFiberService) throw new Error(invalidServiceDataType);
      return new QuotationProductDarkFiber(service.serviceTypeSelect.value, service.darkFiberService.fiberNumberSelect.value, service.darkFiberService.sectionLengthInput);
    case exports.ProductId.COLOCATION_ID:
      {
        if (!service.collocationService) throw new Error(invalidServiceDataType);
        return new QuotationProductCollocation(service.serviceTypeSelect.value, service.collocationService.emplacementTypeSelect.value, service.collocationService.collocationUnitSelect.value, service.collocationService.collocationQuantitySelect.label);
      }
    case exports.ProductId.TOWERING_ID:
      if (!service.towering) throw new Error(invalidServiceDataType);
      return new QuotationProductTowering(service.serviceTypeSelect.value, service.towering.structureTypeSelect.value, parseInt(service.towering.colocationPositionSelect.value), parseInt(service.towering.structureHeightSelect.label), service.towering.structureHeightSelect.value);
    default:
      throw new Error('Invalid service type');
  }
};
const localServiceSummary = service => {
  const type = service.serviceType || service.serviceTypeSelect.label || '';
  const bandwidth = service.bandwidthSelect.label || service.bandwidth || '';
  return [type, bandwidth].join(' - ');
};
const serviceSummary = service => {
  const type = service.serviceType || '';
  const bandwidth = service.bandwidth || '';
  return [type, bandwidth].join(' - ');
};
const localServiceCoordinates = service => {
  const validOrigin = isValidCoordinate({
    lat: service.originLatitude,
    lng: service.originLongitude
  });
  const validDestination = isValidCoordinate({
    lat: service.destinationLatitude,
    lng: service.destinationLongitude
  });
  return {
    origin: validOrigin ? {
      latitude: validOrigin.lat,
      longitude: validOrigin.lng
    } : undefined,
    destination: validDestination ? {
      latitude: validDestination.lat,
      longitude: validDestination.lng
    } : undefined
  };
};
const populateServiceFromCalculateResponse = (localService, serverResponse, intl) => {
  const baseMerge = Object.assign({}, localService, serverResponse);
  const finalMerge = Object.assign({}, baseMerge, {
    deadlineUpdated: baseMerge.deadline,
    statusName: intl.formatMessage({
      id: serverResponse.status === exports.ServiceServerStatus.CALCULATED ? 'SERVICE.STATUS.CALCULATED' : 'SERVICE.STATUS.NOT_CALCULATED'
    })
  });
  return curateService(finalMerge);
};
const populateServiceFromUpdateResponse = (localService, serverResponse, intl, preUpdatedService) => {
  const isFirstMrcUpdate = (preUpdatedService === null || preUpdatedService === void 0 ? void 0 : preUpdatedService.mrcAdjustment) === localService.mrc;
  const isFirstNrcUpdate = (preUpdatedService === null || preUpdatedService === void 0 ? void 0 : preUpdatedService.nrcAdjustment) === localService.nrc;
  const baseMerge = Object.assign({}, localService, serverResponse, {
    bandwidthUpdated: serverResponse.bandwidthUpdated || localService.bandwidthUpdated,
    bandwidthUnitUpdated: serverResponse.bandwidthUnitUpdated || localService.bandwidthUnitUpdated,
    capacityUpdated: serverResponse.capacityUpdated || localService.capacityUpdated,
    deadlineUpdated: serverResponse.deadlineUpdated || localService.deadlineUpdated,
    nrcAdjustment: isFirstNrcUpdate ? serverResponse.nrcAdjustment || undefined : serverResponse.nrcAdjustment || localService.nrcAdjustment,
    mrcAdjustment: isFirstMrcUpdate ? serverResponse.mrcAdjustment || undefined : serverResponse.mrcAdjustment || localService.mrcAdjustment
  });
  const finalMerge = Object.assign({}, baseMerge, {
    bandwidthSelect: {
      capacity: baseMerge.capacityUpdated || baseMerge.capacity,
      bandwidth: baseMerge.bandwidthUpdated || baseMerge.bandwidth,
      unit: baseMerge.bandwidthUnitUpdated || baseMerge.bandwidthUnit,
      label: makeBandwidthLabel(baseMerge.bandwidthUpdated || baseMerge.bandwidth, baseMerge.bandwidthUnitUpdated || baseMerge.bandwidthUnit),
      value: baseMerge.bandwidthSelect.value
    },
    statusName: intl.formatMessage({
      id: serverResponse.status === exports.ServiceServerStatus.CALCULATED ? 'SERVICE.STATUS.CALCULATED' : 'SERVICE.STATUS.NOT_CALCULATED'
    })
  });
  return curateService(finalMerge);
};
const populateLocalServiceFromServerResponse = (serverResponse, quotationData) => {
  var _serverResponse$origi, _serverResponse$origi2, _serverResponse$origi3, _serverResponse$origi4, _serverResponse$desti, _serverResponse$desti2, _serverResponse$desti3, _serverResponse$desti4;
  const localServiceData = {
    serviceTypeSelect: {
      label: serverResponse.serviceType,
      value: serviceTypeIds.get(serverResponse.serviceType) || ''
    },
    originPopSelect: {
      label: ((_serverResponse$origi = serverResponse.originPoint) === null || _serverResponse$origi === void 0 ? void 0 : _serverResponse$origi.name) || '',
      value: ''
    },
    originAddress: ((_serverResponse$origi2 = serverResponse.originPoint) === null || _serverResponse$origi2 === void 0 ? void 0 : _serverResponse$origi2.address) || '',
    originLatitude: (_serverResponse$origi3 = serverResponse.originPoint) === null || _serverResponse$origi3 === void 0 ? void 0 : _serverResponse$origi3.latitude,
    originLongitude: (_serverResponse$origi4 = serverResponse.originPoint) === null || _serverResponse$origi4 === void 0 ? void 0 : _serverResponse$origi4.longitude,
    destinationPopSelect: {
      label: ((_serverResponse$desti = serverResponse.destinationPoint) === null || _serverResponse$desti === void 0 ? void 0 : _serverResponse$desti.name) || '',
      value: ''
    },
    destinationAddress: ((_serverResponse$desti2 = serverResponse.destinationPoint) === null || _serverResponse$desti2 === void 0 ? void 0 : _serverResponse$desti2.address) || '',
    destinationLatitude: (_serverResponse$desti3 = serverResponse.destinationPoint) === null || _serverResponse$desti3 === void 0 ? void 0 : _serverResponse$desti3.latitude,
    destinationLongitude: (_serverResponse$desti4 = serverResponse.destinationPoint) === null || _serverResponse$desti4 === void 0 ? void 0 : _serverResponse$desti4.longitude,
    bandwidthSelect: {
      value: uuid.v4(),
      label: serverResponse.bandwidth ? serverResponse.bandwidth + " " + unitMappings.get(serverResponse.bandwidthUnit) : serverResponse.capacity + " " + unitMappings.get(exports.BandwidthUnits.MBPS),
      unit: serverResponse.bandwidthUnit,
      capacity: serverResponse.capacity,
      bandwidth: serverResponse.bandwidth
    },
    transportLayerSelect: {
      label: serverResponse.transportLayer || '',
      value: serverResponse.transportLayer || ''
    },
    state: exports.ServiceLocalState.Computed,
    countrySelect: {
      label: '',
      value: quotationData.idPais || ''
    },
    corporateGroupSelect: {
      label: '',
      value: quotationData.idGrupoCorporativo || ''
    },
    clientSelect: {
      label: '',
      value: quotationData.idCliente || ''
    },
    isBulk: quotationData.isBulk,
    technologySelect: emptyUfinetSelectOption,
    accessSelect: emptyUfinetSelectOption,
    redundancySelect: emptyUfinetSelectOption,
    transmissionSelect: emptyUfinetSelectOption,
    standardSelect: emptyUfinetSelectOption,
    subStandardSelect: emptyUfinetSelectOption
  };
  const baseMerge = Object.assign({}, localServiceData, serverResponse);
  const finalMerge = Object.assign({}, baseMerge, {
    bandwidthSelect: {
      capacity: baseMerge.capacityUpdated || baseMerge.capacity,
      bandwidth: baseMerge.bandwidthUpdated || baseMerge.bandwidth,
      unit: baseMerge.bandwidthUnitUpdated || baseMerge.bandwidthUnit,
      label: makeBandwidthLabel(baseMerge.bandwidthUpdated || baseMerge.bandwidth, baseMerge.bandwidthUnitUpdated || baseMerge.bandwidthUnit),
      value: baseMerge.bandwidthSelect.value
    }
  });
  return curateService(finalMerge);
};
function curateService(service) {
  return curateNulls(service);
}

const url$b = process.env.REACT_APP_URL_BACK_AQS + "api/service";
const servicesService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData
  });
  return {
    calculateService: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$b + "/calculate", criteria, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    updateService: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$b + "/update", criteria, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteServices: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$b + "/delete", criteria, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const localStorageAuthKey$1 = 'ufinet-auth';
const loginSSOTimeout = 25000;
const authChannel = new broadcastChannel.BroadcastChannel('ufinet-auth');
const authService = {
  getLoginPwdUrl: () => process.env.REACT_APP_URL_BACK_PORTAL + "auth/pwd/login",
  getLoginOAuth2Url: () => process.env.REACT_APP_URL_BACK_PORTAL + "auth/oauth2/login",
  getValidateTokenUrl: () => process.env.REACT_APP_URL_BACK_PORTAL + "api/auth/token/validate",
  getRefreshTokenUrl: () => process.env.REACT_APP_URL_BACK_PORTAL + "api/auth/token/refresh",
  getSSOLoginUrl: () => process.env.REACT_APP_URL_BACK_PORTAL + "auth/sso/login",
  initLoginPwd: function (setToken, username, onTokenReceived, onFrameClose) {
    if (username === void 0) {
      username = '';
    }
    try {
      const loginUrl = authService.getLoginPwdUrl() + ("" + (username ? "?username=" + username : ''));
      return Promise.resolve(authService.initLogin(loginUrl, setToken, onTokenReceived, onFrameClose));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  initLoginOAuth2: function (setToken, username, onTokenReceived, onFrameClose) {
    if (username === void 0) {
      username = '';
    }
    try {
      return Promise.resolve(authService.initLogin(authService.getLoginOAuth2Url() + ("" + (username ? "?username=" + username : '')), setToken, onTokenReceived, onFrameClose));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  initLogin: function (loginUrl, setToken, onTokenReceived, onFrameClose) {
    if (onTokenReceived === void 0) {
      onTokenReceived = () => {};
    }
    if (onFrameClose === void 0) {
      onFrameClose = () => {};
    }
    try {
      const loginWindow = window.open(loginUrl, '_blank', 'toolbar=0,location=0,menubar=0,popup=true');
      const timer = setInterval(() => {
        if (loginWindow !== null && loginWindow !== void 0 && loginWindow.closed) {
          clearInterval(timer);
          onFrameClose();
        }
      }, 1000);
      return Promise.resolve(new Promise((resolve, reject) => {
        window.addEventListener('message', event => {
          if (event.origin === ("" + process.env.REACT_APP_URL_BACK_PORTAL).replace(/\/$/, '')) {
            var _event$data;
            if (((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.eventType) === exports.AuthEvent.LOGIN_FINISH) {
              const token = event.data.eventData;
              setToken(token);
              onTokenReceived(token);
              authService.validateToken(token.accessToken).then(resolve).catch(reject);
              loginWindow && loginWindow.close();
            }
          }
        }, false);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  initSSOLogin: function (setToken) {
    try {
      return Promise.resolve(new Promise((resolve, reject) => {
        window.addEventListener('message', event => {
          if (event.origin === ("" + process.env.REACT_APP_URL_BACK_PORTAL).replace(/\/$/, '')) {
            var _event$data2, _event$data3;
            if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.eventType) === exports.AuthEvent.LOGIN) {
              const receivedToken = event.data.eventData || undefined;
              setToken(receivedToken);
              resolve();
            } else if (((_event$data3 = event.data) === null || _event$data3 === void 0 ? void 0 : _event$data3.eventType) === exports.AuthEvent.LOGOUT) {
              authChannel.postMessage({
                type: exports.AuthEvent.LOGOUT
              });
            }
          }
        }, false);
        setTimeout(reject, loginSSOTimeout);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  setUpBroadcastChannel: function setUpBroadcastChannel(options) {
    if (options === void 0) {
      options = {};
    }
    const {
      onLogoutReceived
    } = options;
    authChannel.onmessage = e => {
      switch (e.type) {
        case exports.AuthEvent.LOGOUT:
          onLogoutReceived && onLogoutReceived();
          break;
      }
    };
  },
  initLogout: function (authFrame) {
    try {
      return Promise.resolve(new Promise((resolve, reject) => {
        if (!authFrame.contentWindow) reject(new Error('Could not logout'));else {
          authFrame.contentWindow.postMessage({
            eventType: exports.AuthEvent.LOGOUT
          }, '*');
          resolve();
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  getAccessToken: () => {
    var _auth$token, _JSON$parse;
    const auth = JSON.parse(localStorage.getItem(localStorageAuthKey$1) || '{}');
    const parsedToken = typeof auth.token === 'object' ? auth === null || auth === void 0 ? void 0 : (_auth$token = auth.token) === null || _auth$token === void 0 ? void 0 : _auth$token.accessToken : (_JSON$parse = JSON.parse(auth.token)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.accessToken;
    return parsedToken;
  },
  getRefreshToken: () => {
    var _auth$token2, _JSON$parse2;
    const auth = JSON.parse(localStorage.getItem(localStorageAuthKey$1) || '{}');
    const parsedToken = typeof auth.token === 'object' ? auth === null || auth === void 0 ? void 0 : (_auth$token2 = auth.token) === null || _auth$token2 === void 0 ? void 0 : _auth$token2.refreshToken : (_JSON$parse2 = JSON.parse((auth === null || auth === void 0 ? void 0 : auth.token) || '{}')) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.refreshToken;
    return parsedToken;
  },
  validateToken: function (accessToken) {
    try {
      return Promise.resolve(new Promise((resolve, reject) => {
        const requestToken = accessToken || authService.getAccessToken();
        if (!requestToken) reject(new Error('Could not validate token'));else {
          FetchAPI.post(authService.getValidateTokenUrl(), {
            accessToken: requestToken
          }, {
            sendAuth: false
          }).then(resolve).catch(reject);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  refreshToken: function (setToken, _refreshToken) {
    try {
      return Promise.resolve(new Promise((resolve, reject) => {
        const requestToken = _refreshToken || authService.getRefreshToken();
        if (!requestToken) reject(new Error('Coudl not validate token'));else {
          FetchAPI.post(authService.getRefreshTokenUrl(), {
            refreshToken: requestToken
          }, {
            sendAuth: false
          }).then(response => {
            const tokenData = {
              accessToken: response.accessToken,
              refreshToken: requestToken
            };
            setToken(tokenData);
            return resolve(response);
          }).catch(reject);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  },
  isAuthenticated: (setToken, tokenData) => {
    return new Promise((resolve, reject) => {
      authService.validateToken(tokenData === null || tokenData === void 0 ? void 0 : tokenData.accessToken).then(resolve).catch(() => {
        authService.refreshToken(setToken, tokenData === null || tokenData === void 0 ? void 0 : tokenData.refreshToken).then(_ref => {
          let {
            accessToken
          } = _ref;
          return authService.isAuthenticated(setToken, Object.assign({}, tokenData, {
            accessToken
          }));
        }).catch(reject);
      });
    });
  }
};

const url$c = process.env.REACT_APP_URL_BACK_UFINET_HUB + "api/client";
const AQS_QUERY_PARAMETER_NAME = 'aqs';
const clientService = (authData, configuration) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData,
    sendApiKey: true
  });
  return {
    findAll: function (options) {
      try {
        return Promise.resolve(FetchAPI.get_params(url$c + "/find", {
          [AQS_QUERY_PARAMETER_NAME]: (configuration === null || configuration === void 0 ? void 0 : configuration.frontendApplication) === exports.FrontEndApplication.AQS ? true : undefined
        }, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    find: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.get_params(url$c + "/find/" + criteria.clientId, {
          [AQS_QUERY_PARAMETER_NAME]: (configuration === null || configuration === void 0 ? void 0 : configuration.frontendApplication) === exports.FrontEndApplication.AQS ? true : undefined
        }, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    findClients: function (criteria, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$c + "/find", criteria, Object.assign({}, fetchOptions, options, {
          queryParameters: {
            [AQS_QUERY_PARAMETER_NAME]: (configuration === null || configuration === void 0 ? void 0 : configuration.frontendApplication) === exports.FrontEndApplication.AQS ? true : undefined
          }
        })));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$d = process.env.REACT_APP_URL_BACK_UFINET_HUB + "api/contact";
const contactsService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData,
    sendApiKey: true
  });
  return {
    findContactsByClientId: function (contactRequest, options) {
      try {
        return Promise.resolve(FetchAPI.post(url$d + "/find", contactRequest, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$e = process.env.REACT_APP_URL_BACK_UFINET_HUB + "api/corporate-group";
const corporateGroupService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData,
    sendApiKey: true
  });
  return {
    getAllCorporateGroups: function () {
      try {
        return Promise.resolve(FetchAPI.get("" + url$e, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getCorporateGroupsByIds: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(url$e + "/find/byId", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getCorporateGroupsByCountries: function (criteria) {
      try {
        return Promise.resolve(FetchAPI.post(url$e + "/find/byCountry", criteria, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const corporateGroupToSelectOption = cg => ({
  label: cg.name,
  value: cg.id
});

const url$f = process.env.REACT_APP_URL_BACK_UFINET_HUB + "api/countries";
const countriesService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData,
    sendApiKey: true
  });
  return {
    getAllCountries: function () {
      try {
        return Promise.resolve(FetchAPI.get(url$f, fetchOptions));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

(function (UfinetErrorCode) {
  UfinetErrorCode[UfinetErrorCode["GENERIC"] = 0] = "GENERIC";
  UfinetErrorCode[UfinetErrorCode["BANDWIDTH_COMBINATION_NOT_FOUND"] = 1] = "BANDWIDTH_COMBINATION_NOT_FOUND";
  UfinetErrorCode[UfinetErrorCode["QUOTATION_POINTS_EXCEEDS_LENGTH"] = 2] = "QUOTATION_POINTS_EXCEEDS_LENGTH";
})(exports.UfinetErrorCode || (exports.UfinetErrorCode = {}));

const url$g = process.env.REACT_APP_URL_BACK_GFA + "api/country-settings";
const countriesParamsService = (authData, intl) => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData,
    sendApiKey: true
  });
  return {
    findAll: function (options) {
      try {
        return Promise.resolve(FetchAPI.get(url$g, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    findById: function (id) {
      try {
        return Promise.resolve(FetchAPI.get(url$g + "/" + id, Object.assign({}, fetchOptions)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    deleteMany: function (ids, options) {
      try {
        return Promise.resolve(FetchAPI.deleteWithBody(url$g, ids, Object.assign({}, fetchOptions, {
          notification: successNotifications.deleteByIdsList(intl, {
            section: intl.formatMessage({
              id: 'COUNTRY.PARAMETERS'
            }).toLowerCase()
          })
        }, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: function (formData, options) {
      try {
        return Promise.resolve(FetchAPI.post_formdata(url$g, formData, Object.assign({}, fetchOptions, options))).then(function () {});
      } catch (e) {
        return Promise.reject(e);
      }
    },
    update: function (id, formData, options) {
      try {
        return Promise.resolve(FetchAPI.patch_formdata(url$g + "/" + id, formData, Object.assign({}, fetchOptions, options))).then(function () {});
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

const url$h = process.env.REACT_APP_URL_BACK_GFA + "api/country-settings/languages";
const languagesService = authData => {
  const fetchOptions = Object.assign({}, defaultOptionsFetch, {
    authenticationData: authData,
    sendApiKey: true
  });
  return {
    findAll: function (options) {
      try {
        return Promise.resolve(FetchAPI.get(url$h, Object.assign({}, fetchOptions, options)));
      } catch (e) {
        return Promise.reject(e);
      }
    }
  };
};

exports.AUTO_FIGURES = AUTO_FIGURES;
exports.AccessAreaStatusArray = AccessAreaStatusArray;
exports.AreaStatusColors = AreaStatusColors;
exports.AreaTypeColors = AreaTypeColors;
exports.AreaTypeZindex = AreaTypeZindex;
exports.AuthContext = AuthContext;
exports.Authority = Authority;
exports.ComplexEnum = ComplexEnum;
exports.EmptyPagingData = EmptyPagingData;
exports.FetchAPI = FetchAPI;
exports.I18N_CONFIG_KEY = I18N_CONFIG_KEY;
exports.I18nContext = I18nContext;
exports.InfrastructureTypeOptions = InfrastructureTypeOptions;
exports.InitialAuthData = InitialAuthData;
exports.KmzMaxSize = KmzMaxSize;
exports.LabelValueEnum = LabelValueEnum;
exports.NotificationTranslations = NotificationTranslations;
exports.QuotationPointAddress = QuotationPointAddress;
exports.QuotationPointCoordinates = QuotationPointCoordinates;
exports.QuotationPointPop = QuotationPointPop;
exports.QuotationProductEline = QuotationProductEline;
exports.QuotationProductInternet = QuotationProductInternet;
exports.SelectOptionMapper = SelectOptionMapper;
exports.SelectOptionTranslateMapper = SelectOptionTranslateMapper;
exports.SpecialCountries = SpecialCountries;
exports.TOAST_CONTAINER_ID = TOAST_CONTAINER_ID;
exports.TransportLayerSelectOptions = TransportLayerSelectOptions;
exports.UfinetSelectBaseStyles = UfinetSelectBaseStyles;
exports.ZoneTypeOptions = ZoneTypeOptions;
exports.allModulePermissions = allModulePermissions;
exports.areaService = areaService;
exports.areaStatusToText = areaStatusToText;
exports.authService = authService;
exports.bandwidthsService = bandwidthsService;
exports.browserDownload = browserDownload;
exports.buildingAccessCostsService = buildingAccessCostsService;
exports.bulkQuotationService = bulkQuotationService;
exports.bulkQuotationXlsService = bulkQuotationXlsService;
exports.checkIsActive = checkIsActive;
exports.clickedOnElementById = clickedOnElementById;
exports.clientService = clientService;
exports.compareDates = compareDates;
exports.compareString = compareString;
exports.compareStringIgnoreCase = compareStringIgnoreCase;
exports.contactsService = contactsService;
exports.convertToLocalTZ = convertToLocalTZ;
exports.coordinatesCellNumberFormattingSettings = coordinatesCellNumberFormattingSettings;
exports.corporateGroupService = corporateGroupService;
exports.corporateGroupToSelectOption = corporateGroupToSelectOption;
exports.countDecimals = countDecimals;
exports.countriesParamsService = countriesParamsService;
exports.countriesService = countriesService;
exports.countryParamsFormattingSettings = countryParamsFormattingSettings;
exports.countryParamsService = countryParamsService;
exports.curateNulls = curateNulls;
exports.defaultCellNumberFormattingSettings = defaultCellNumberFormattingSettings;
exports.defaultColor = defaultColor;
exports.defaultFilterSettings = defaultFilterSettings;
exports.defaultOptions = defaultOptions;
exports.defaultOptionsFetch = defaultOptionsFetch;
exports.defaultPageNumber = defaultPageNumber;
exports.defaultPageSize = defaultPageSize;
exports.defaultPagingParameters = defaultPagingParameters;
exports.domainMailRegExp = domainMailRegExp;
exports.economicModelCostsService = economicModelCostsService;
exports.emptyFileUploadData = emptyFileUploadData;
exports.emptyUfinetSelectOption = emptyUfinetSelectOption;
exports.equipmentCostsService = equipmentCostsService;
exports.fillOnChangeCountry = fillOnChangeCountry;
exports.fillOnClientChange = fillOnClientChange;
exports.fillOnCorporateGroupChange = fillOnCorporateGroupChange;
exports.foCostsService = foCostsService;
exports.formDataFromObject = formDataFromObject;
exports.formInitialCountryParams = formInitialCountryParams;
exports.formatCellNumber = formatCellNumber;
exports.formatDateToString = formatDateToString;
exports.formatFileSize = formatFileSize;
exports.getAreaStatusTranslation = getAreaStatusTranslation;
exports.getArrayFromObject = getArrayFromObject;
exports.getAvailableFilterOptions = getAvailableFilterOptions;
exports.getConfig = getConfig;
exports.getCurrentUrl = getCurrentUrl;
exports.getEnumKeyFromEnumValue = getEnumKeyFromEnumValue;
exports.getNotificationTranslation = getNotificationTranslation;
exports.getObjectFromArray = getObjectFromArray;
exports.getTableTranslations = getTableTranslations;
exports.getTranslation = getTranslation;
exports.i18nInitialState = i18nInitialState;
exports.infrastructureCostsService = infrastructureCostsService;
exports.infrastructureTypeMappings = infrastructureTypeMappings;
exports.initialQuotationBulk = initialQuotationBulk;
exports.initialQuotationIndividual = initialQuotationIndividual;
exports.initialServiceBulk = initialServiceBulk;
exports.initialServiceIndividual = initialServiceIndividual;
exports.internalMailRegExp = internalMailRegExp;
exports.isEmptyObject = isEmptyObject;
exports.isFormattedDate = isFormattedDate;
exports.isNumeric = isNumeric;
exports.isOverflowing = isOverflowing;
exports.isPropValuesEqual = isPropValuesEqual;
exports.isValidCoordinate = isValidCoordinate;
exports.joinValuesWithConjunctionAndSeparator = joinValuesWithConjunctionAndSeparator;
exports.kmzAreaService = kmzAreaService;
exports.kmzAreasService = kmzAreasService;
exports.kmzFilesService = kmzFilesService;
exports.kmzItemsService = kmzItemsService;
exports.labelAndValueFilter = labelAndValueFilter;
exports.languagesService = languagesService;
exports.localServiceCoordinates = localServiceCoordinates;
exports.localServiceSummary = localServiceSummary;
exports.localStorageAuthKey = localStorageAuthKey;
exports.makeBandwidthLabel = makeBandwidthLabel;
exports.makeSelectOptionFromBandwidth = makeSelectOptionFromBandwidth;
exports.mapFromPagedResponseToPagingData = mapFromPagedResponseToPagingData;
exports.mkFormSchema = mkFormSchema;
exports.mkUrlWithSearchParams = mkUrlWithSearchParams;
exports.mockAuthData = mockAuthData;
exports.nanToValue = nanToValue;
exports.networkItemTypeTranslations = networkItemTypeTranslations;
exports.networkItemsService = networkItemsService;
exports.noContentPlaceholder = noContentPlaceholder;
exports.notificationParty = notificationParty;
exports.numberInRange = numberInRange;
exports.numberInRangeInt = numberInRangeInt;
exports.onFormikChanges = onFormikChanges;
exports.onFormikCheckboxChanges = onFormikCheckboxChanges;
exports.onFormikNumberChanges = onFormikNumberChanges;
exports.onFormikTextChanges = onFormikTextChanges;
exports.onFormikTrimField = onFormikTrimField;
exports.onSelectionChangePreventDefaultsRemoval = onSelectionChangePreventDefaultsRemoval;
exports.onlyLabelAndBeginsWithLabelFilter = onlyLabelAndBeginsWithLabelFilter;
exports.onlyLabelFilter = onlyLabelFilter;
exports.onlyLabelFilterSettings = onlyLabelFilterSettings;
exports.parseDomainFromEmail = parseDomainFromEmail;
exports.phoneRegExp = phoneRegExp;
exports.popService = popService;
exports.populateLocalServiceFromServerResponse = populateLocalServiceFromServerResponse;
exports.populateServiceFromCalculateResponse = populateServiceFromCalculateResponse;
exports.populateServiceFromUpdateResponse = populateServiceFromUpdateResponse;
exports.predicateEqualsObject = predicateEqualsObject;
exports.productsService = productsService;
exports.quotationRequestFromServicesModel = quotationRequestFromServicesModel;
exports.quotationService = quotationService;
exports.randomEnumElement = randomEnumElement;
exports.removeDuplicates = removeDuplicates;
exports.removeFalsyProperties = removeFalsyProperties;
exports.selectColorStyles = selectColorStyles;
exports.serviceCalculateRequestFromServiceModel = serviceCalculateRequestFromServiceModel;
exports.serviceProductFromStateService = serviceProductFromStateService;
exports.serviceSummary = serviceSummary;
exports.serviceTypeIds = serviceTypeIds;
exports.serviceUpdateRequestFromServiceModel = serviceUpdateRequestFromServiceModel;
exports.servicesService = servicesService;
exports.setAqsErrorHelper = setAqsErrorHelper;
exports.setLanguage = setLanguage;
exports.silentFailureOptionsFetch = silentFailureOptionsFetch;
exports.sortAlphabetically = sortAlphabetically;
exports.stringToColor = stringToColor;
exports.successNotifications = successNotifications;
exports.tableCostsFormattingSettings = tableCostsFormattingSettings;
exports.tableDataFormattingSettings = tableDataFormattingSettings;
exports.tableDeadlineFormattingSettings = tableDeadlineFormattingSettings;
exports.tirFormattingSettings = tirFormattingSettings;
exports.toAbsoluteUrl = toAbsoluteUrl;
exports.toggleFullScreen = toggleFullScreen;
exports.totalsFormattingSettings = totalsFormattingSettings;
exports.typesAreaService = typesAreaService;
exports.unitMappings = unitMappings;
exports.useAqsError = useAqsError;
exports.useAsync = useAsync;
exports.useAuthData = useAuthData;
exports.useDOMEvent = useDOMEvent;
exports.useDebouncedCallback = useDebouncedCallback;
exports.useDeepEffect = useDeepEffect;
exports.useInViewport = useInViewport;
exports.useInternalUser = useInternalUser;
exports.useLang = useLang;
exports.useListener = useListener;
exports.useLoading = useLoading;
exports.useLongPress = useLongPress;
exports.useModal = useModal;
exports.useSelectClear = useSelectClear;
exports.useTranslator = useTranslator;
exports.useUserDomain = useUserDomain;
exports.user = user;
exports.userTypeMappings = userTypeMappings;
exports.userWithDetail = userWithDetail;
exports.zoneTypeMappings = zoneTypeMappings;
//# sourceMappingURL=index.js.map
